import seedrandom from 'seedrandom';
import * as pako from 'pako';
import { get } from 'svelte/store';
import { cc, clearSelection, info, pause, waitMillis, chooseCards, choose, debounce, getActionLog, formatBytes, activePlayer } from './ui.js';
import { clone, res, state, ui, prefs } from './stores.js';
import { allActions, inPlay, getLocation, cardsInPlay, removeAllAway, handleOngoingChange, stackIncludes, closeAllLooks, closeLook, cardResourceTypes, updateAllTypeGains, tableEffectsActive, drawCard, completeMission, dbUpdateMissions, updateMissions, possArray, matches, isInPlay, getActions, allTokenTypes, inPlayLocations, scalarIfOne, setHidden, sdCards, availableAT, atPool, removeTopOfEachMarketDeck } from './card_actions.js';
import { endGame } from './turns.js'
import { saveGame, saveGameSoon } from './save.js';
import { botValue } from './bot.js';
import { sendUpdate, handover, isMe, launchReaction, getUID, getUsername, changePlayer } from './net.js';
import { autoCheckReaction, autoReaction, cardOwner, doActionPause, getCardEffect, logDid, meetsThreshold, ongoingEffects, ongoingPlayer, resolveCondition, resolveCount, resolveEffects, resolveNum, trawlFor, validEffect, nonCardListPrep, upperInitial, cannotDoOp } from './parse.js';
import { tick } from 'svelte/internal';
import * as jsonpatch from 'fast-json-patch';
//import * as diff from 'deep-diff';
import * as Diff from 'diff';
import { getCampaignBotLevel } from './campaign.js';
import { parseCards, pegParse } from './pegparse.js';
import { canPay, getCostInfo, pay, renderCost } from './costs.js';
import { preloadNewImages, resetCodes } from './card_images.js';
import { allScoreableCards, scorePlayer } from './scores.js';
import { janewayPassives } from './janeway.js';
import { dbUpdateGame, untilQueueEmpties, updateGame } from './sb.js';
import { rollbackMessages } from './anydb.js';
import { nanoid } from 'nanoid';
import { resetContinuationBaseline } from './continuation.js';
import { perfCount, perfMeasure, perfMeasureAsync, perfSampleMeasure, perfStart } from './perf.js';
import { recordSlot } from './frames.js';
//import { checkCustomMissions } from './archer.js';


let uniqueIdNo = 1;
let cardIndexByState = new WeakMap();

export function getUniqueID(){
    return uniqueIdNo++;
}

export function resetUniqueID(){
    uniqueIdNo = 1;
    resetCodes();
    cardIndexByState = new WeakMap();
}

export function genCard(c){
    if(!c || !c.name){
        throw 'Copying nonexistent card!';
    }
    let card = clone(c); //Object.assign({}, c);
    card.uniqueID = getUniqueID();
    /*state.update(s => {
        s.cardsByID[card.uniqueID] = card; // TODO will this stay updated? Not sure
        if(c.ships){
            for(let ship of c.ships){
                s.cardsByShip[ship] = card;
            }
        }
        return s;
    })*/
    return card;
}

function addCardToIndex(index, c){
    if(!c || !c.uniqueID) return;
    index.set(String(c.uniqueID), c);
    if(Array.isArray(c.beamed)){
        for(let b of c.beamed){
            addCardToIndex(index, b);
        }
    }
}

export function rebuildCardIndex(s = get(state)){
    const index = new Map();
    if(!s) return index;
    for(let deck of Object.values(s.commons || {})){
        if(!Array.isArray(deck)) continue;
        for(let c of deck) addCardToIndex(index, c);
    }
    for(let p of s.players || []){
        for(let deck of Object.values(p.decks || {})){
            if(!Array.isArray(deck)) continue;
            for(let c of deck) addCardToIndex(index, c);
        }
        for(let deck of Object.values(p.dashboard || {})){
            if(!Array.isArray(deck)) continue;
            for(let c of deck) addCardToIndex(index, c);
        }
    }
    cardIndexByState.set(s, index);
    return index;
}

function currentCardIndex(s = get(state)){
    let index = cardIndexByState.get(s);
    if(!index) index = rebuildCardIndex(s);
    return index;
}

function findCardFromLog(s, id){
    let info = s.cardLog[id];
    if(!info) return null;
    if(info.area == 'commons'){
        return s.commons[info.deck].find(c => c && c.uniqueID == id);
    }else if(info.area == 'players'){
        return s.players[info.player].decks[info.deck].find(c => c && c.uniqueID == id);
    }else if(info.area == 'player_dashboards'){
        return s.players[info.player].dashboard[info.deck].find(c => c && c.uniqueID == id);
    }else if(info.area == 'beamed'){
        let hostInfo = s.cardLog[info.deck];
        if(hostInfo.area == 'beamed') throw 'cannot stack beamed cards!'
        let host = getCard(info.deck);
        if(!host || !host.beamed){
            console.log('Trying to find non-existent card host!');
            return null;
        }
        return host.beamed.find(c => c && c.uniqueID == id);
    }
    return null;
}

export function markUndoTurnStart(){
    if(get(res).BvB) return;
    let checkpoint = perfMeasure('state.cloneTurnStartState', () => clone(get(state)));
    res.update(r => {
        r.prevStates = [];
        r.savedState = checkpoint;
        r.undoThreshold = 0;
        r.turnStartUndo = {
            turn: get(state).turn,
            player: get(state).currentPlayer
        };
        return r;
    })
}

export function getOrigDeck(d){
    if(!d || !d[0]) return [];
    let c = Array.isArray(d) ? d[0] : d;
    let deck;
    let info = get(state).cardLog[c.uniqueID];
    if(info.area == 'commons'){
        deck = get(state).commons[info.deck];
    }else if(info.area == 'players'){
        deck = get(state).players[info.player].decks[info.deck];
    }else if(info.area == 'beamed'){
        deck = cardByID([info.deck].beamed);
    }
    return deck;
}

export function getMarketCards(){
    let s = get(state);
    return [s.commons.people[0], s.commons.cargo[0], s.commons.ships[0], s.commons.allies[0]].filter(c => c);
}

export function getNeutralZone(){
    let ret = get(state).commons.neutral_zone.filter(c => c);
    return ret;
}

export function badlands(){
    return getNeutralZone().find(c => isBadlands(c));
}

export function isBadlands(c){
    if(!c) return false;
    if(typeof c == 'number') c = getCard(c);
    return c.name == 'Badlands' || c.name == 'The Badlands';
}

export function shuffleDeck(d){
    let deck = getOrigDeck(d);
    shuffle(deck);
}

export function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(prng() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

export function prng(){
    let rng = seedrandom("", {state: get(state).random.state}); // Should be as saved
    let num = rng();
    state.update(s => {
        s.random.state = rng.state();
        return s;
    });
    /*state.update(s => {
        s.random.state = rng.state();f
        return s;
    }); // TODO is this right?*/
    //state.random.state = rng.state();
    return num;
}

export function getCard(id){
    return perfSampleMeasure('lookup.getCard', 200, () => {
        if(typeof id === 'object'){
            console.log('getting card with object', id)
            return id; // Just in 
        }
        /*if(typeof id === 'string'){
            // mission
            let deck = id.slice(0, id.indexOf('_'));
            let num = parseInt(id.slice(id.indexOf('_')+1));
            let dash = get(res).dashboards[deck];
            let p = get(state).players.find(p => p.captain == deck);
            if(p){
                if(p.dashSide == 'basic') dash = get(res).dashboards[deck+'_basic'];
            }else{
                if(get(state).gameType == 'basic') dash = get(res).dashboards[deck+'_basic'];
            }
            
            if(dash) return dash.missions[num - 1];
        }*/
        let s = get(state);
        let indexed = currentCardIndex(s).get(String(id));
        if(indexed) return indexed;
        let found = findCardFromLog(s, id);
        if(found) currentCardIndex(s).set(String(found.uniqueID), found);
        if(found) return found;
        console.log('card not found!', id)
        return null;
    }, {id});
}

export function allCards(includeDestroyed = false){
    return perfMeasure('lookup.allCards', () => {
        let s = get(state);
        let index = currentCardIndex(s);
        return Array.from(index.values()).filter(c => {
            let info = s.cardLog[c.uniqueID];
            return info && (includeDestroyed || info.deck != 'destroyed');
        });
    }, {includeDestroyed});
}

export function cardByID(id){
    let c = getCard(id);
    if(!c) console.log('card not found!', allCards(), id);
    return c;
}

export async function setUp(state, cards){
    //let seed = seedrandom();
    let rng = seedrandom(state.random.seed, {state: true});
    state.random.state = rng.state();
    //state.random.seed = seed;
    state.startDate = Date.now();
    //state.key = new Date().valueOf().toString(36) + Math.random().toString(36).slice(2);
    state.hostPlayer = getUID();
    state.hostUsername = await getUsername();
    state.gameID = nanoid();
    if(get(res).shorterTurns) state.shorterTurns = true;
    state.setupRemoval = setupRemovalChoice();

    if(!get(res).alphaCards){
        cards = cards.filter(c => !c.staging || c.staging != 'ALFA');
    }
    if(!get(res).betaCards){
        cards = cards.filter(c => !c.staging || c.staging != 'BETA');
    }

    if(state.campaign){
        state.players[0].bot = false;
        if(!state.campaignInfo.captain){
            state.campaignInfo.captain = state.players[0].captain;
        };
        state.players[1].bot = true;
        state.players[1].botLevel = getCampaignBotLevel(state.campaignInfo.currentRank, state.campaignInfo.level);
    }

    

    setupMarket(state, cards);

    let common_missions = cards.filter(c => c.suits.includes('mission') && c.deck == 'Missions').filter(c => c.allText).map(c => genCard(c));
    shuffle(common_missions);
    
    for(let i = 0; i < state.players.length; i++){
        
        let p = state.players[i];
        await setupPlayer(p, get(res).cards, i);
        if(p.decks.rewards.length > 0){
            console.log('adding rewards', p.decks.rewards, state.commons.rewards);
            if(!state.commons.rewards) state.commons.rewards = [];
            state.commons.rewards = [...state.commons.rewards, ...p.decks.rewards];
        }
        delete p.decks.rewards;
        if(i != 0 && state.practice) continue;
        
    }

    // Set up opponent decks
    for(let i = 0; i < state.players.length; i++){
        let opp = state.players[1 - i];
        let p = state.players[i];
        if(p.captain == 'Borg Queen' && opp.bot){
            // Need to separate out devs again
            opp.decks.dev = opp.decks.reserve.filter(c => c.area == 'Development');
            opp.decks.reserve = opp.decks.reserve.filter(c => c.area == 'Reserve');
        }
        for(let c of p.decks.opponent){
            let [o, area] = c.area.split(' ');
            if(area == 'development') area = 'dev';
            if(c.deck == 'Borg Queen'){
                // Only use the relevant type
                // So if the opponent is a bot, only include the surprise ones
                // and vice versa
                if(opp.bot && !c.traits.includes('surprise')) continue;
                if(!opp.bot && c.traits.includes('surprise')) continue;
            }
            if(opp.decks[area]){
                opp.decks[area] = [...opp.decks[area], c];
                if(area == 'deck' || area == 'reserve') shuffle(opp.decks[area]);
            }
        }

        if(p.captain == 'Borg Queen' && opp.bot){
            // Now put them back
            shuffle(opp.decks.dev);
            opp.decks.reserve = [...opp.decks.reserve, ...opp.decks.dev];
            delete opp.decks.dev;
        }
        delete p.decks.opponent;
    }

    if(state.campaign){
        if(state.campaignInfo.liveLong){
            if(state.campaignInfo.nextDilithium) state.players[0].dilithium = state.campaignInfo.nextDilithium;
            if(state.campaignInfo.nextLatinum) state.players[0].latinum = state.campaignInfo.nextLatinum;
        }
        if(state.campaignInfo.onTuesday){
            let p = state.players[0]; // The campaign player: setUp keeps the human in seat 0
            if(state.campaignInfo.games.length > 0 && state.campaignInfo.games[state.campaignInfo.games.length - 1].won){
                p.setAsideAT = 2;
            }else{
                p.setAsideAT = 1;
            }
            if(p.decks.captain[0]){
                let pool = atPool(p);
                if(p.decks.captain[0][pool] && p.decks.captain[0][pool][p.captain]) p.decks.captain[0][pool][p.captain] -= p.setAsideAT;
            }
        }
    }

    state.commons.missions = common_missions;
    state.glory = get(prefs).gloryPile;

    if(state.practiceOppLocations){
        state.players[1].decks.locations = [...state.players[1].decks.locations, ...state.practiceOppLocations];
        delete state.practiceOppLocations; // don't let it into initialState
    }
    
    makeCardLog(state);

    res.update(r => {
        //console.log(r.cards.filter(c => c.ongoingText && c.ongoingText.includes('Reaction:')).map(c => c.ongoingText));
        
        r.initialState = clone(state);
        r.savedState = r.initialState;
        //onsole.log(r.cards.filter(c => c.attack));
        return r;
    })

    updateMissions();
    
    if(get(ui).seats.length == 0){
        let un = await getUsername();
        for(let p of state.players){
            p.username = un;
            ui.update(ui => {
                ui.seats.push({
                    id: 0,
                    uid: getUID(),
                    username: un
                });
                return ui;
            })
        } 
    }
    
    // Preload the images for new cards
    if(!get(res).BvB) preloadNewImages(allCards());

    rebuildCardIndex(state);
    return state;
}

async function playerCampaignSetup(p){
    for(let g of get(state).campaignInfo.games){
        if(g.reward){
            if(g.reward.type == 'add_common'){
                for(let card of possArray(g.reward.card)){
                    let matched = false;
                    let set = ['people','allies','ships','cargo']; // Fix Chef Riker
                    //if(get(state).commons.rewards) set = [...set, 'rewards']; // Fix Chef Riker
                    for(let type of set){
                        for(let c of get(state).commons[type]){
                            if(c.id == card.id || c.name == card.name){
                                matched = true;
                                state.update(s => {
                                    s.commons[type] = s.commons[type].filter(cd => cd.id != c.id);
                                    return s;
                                })
                                c.entered = {
                                    turn: 0,
                                    location: p.captain
                                };
                                p.decks.reinforcements.push(c);
                                break;
                            }
                        }
                        if(matched) break;
                    }
                    if(!matched){
                        for(let c of get(state).commons.junk){
                            // In case it was trashed as per expansion setup
                            if(c.id == card.id || c.name == card.name){
                                matched = true;
                                let com = get(state).commons;
                                console.log(com);
                                state.update(s => {
                                    s.commons.junk = s.commons.junk.filter(cd => cd.id != c.id);
                                    let type = get(res).marketTypes[c.suits[0]];
                                    let junkable = s.commons[type][0];
                                    s.commons[type] = s.commons[type].slice(1);
                                    s.commons[type][0].entered = {
                                        turn: 0,
                                        location: 'market'
                                    };
                                    junkable.entered = {
                                        turn: 0,
                                        location: 'junk'
                                    };
                                    s.commons.junk = [junkable, ...s.commons.junk];
                                    console.log(`Reinforcement card ${c.name} was in junk, so junked ${junkable.name} instead`)
                                    return s;
                                })
                                c.entered = {
                                    turn: 0,
                                    location: p.captain
                                };
                                p.decks.reinforcements.push(c);
                                break;
                            }
                        }
                    }
                    if(!matched){
                        // Look in other sets
                        let c = get(res).allCards.find(c => c.id == card.id || c.name == card.name);
                        if(c){
                            matched = true;
                            c = genCard(c);
                            c.entered = {
                                turn: 0,
                                location: p.captain
                            };
                            p.decks.reinforcements.push(c);
                            if(p.decks.reserve.some(cd => cd.id == c.id)){
                                // remove from reserve! For Georgiou which seems to pull from reserve but call it add_common
                                p.decks.reserve = p.decks.reserve.filter(cd => cd.id != c.id);
                            }
                        }
                    }
                    if(!matched){
                        
                        alert('Unable to find Commons card to add to Reinforcements deck: '+card.name+" ("+card.id+")");
                    }
                }
                
            }else if(g.reward.type == 'add_reserve'){
                for(let card of possArray(g.reward.card)){
                    let matched = false;
                    for(let c of p.decks.reserve){
                        if(c.id == card.id || c.name == card.name){
                            matched = true;
                            p.decks.reserve = p.decks.reserve.filter(cd => cd.id != c.id);
                            p.decks.reinforcements.push(c);
                            break;
                        }
                    }
                    if(!matched){
                        for(let c of p.decks.deck){
                            if(c.id == card.id || c.name == card.name){
                                matched = true;
                                p.decks.deck = p.decks.deck.filter(cd => cd.id != c.id);
                                p.decks.reinforcements.push(c);
                                break;
                            }
                        }
                    }
                    if(!matched){
                        alert('Unable to find Reserve/Starter card to add to Reinforcements deck: '+card.name+" ("+card.id+")");
                    }
                }
            }else if(g.reward.type == 'gain_track'){
                if(g.won){
                    let tracks = ['research', 'influence', 'military'];
                    if(p.captain == 'Borg Queen') tracks = ['collective'];
                    for(let t of tracks){
                        p[t] += g.reward.amount;
                    }
                }else{
                    p[g.reward.track] += g.reward.amount;
                }
                
            }else if(g.reward.type == 'upgrade_reinforce'){
                alert('Need to implement adding upgraded Reinforce card');
            }else if(g.reward.type == 'boost' && g.reward.timing == 'before'){
                logText(`Campaign Reward: ${g.reward.text}`);
                await resolveEffects(p.captain, g.reward.effect, g.reward.attack);
            }else if(g.reward.type == 'supplementary'){
                //if(!p.supplementary) p.supplementary = [];
                //p.supplementary.push(g.reward);
                if(p.decks.captain[0]) p.decks.captain[0].allText += ' Passive: '+g.reward.text;
                if(p.decks.captain[0]) await parseCards([p.decks.captain[0]], true);
            }
        }
    }
    if(p.decks.reinforcements.length > 0){
        let reinforce = get(res).cards.find(c => c.area == 'SOLO CAMPAIGN' && c.name.toLowerCase().trim() == 'reinforce');
        if(reinforce){
            if(get(state).campaignInfo && get(state).campaignInfo.reinforceReserve){
                p.decks.reserve = [...p.decks.reserve, genCard(reinforce)];
                shuffle(p.decks.reserve);
            }else{
                p.decks.deck = [...p.decks.deck, genCard(reinforce)];
                shuffle(p.decks.deck);
            }
            state.update(s => {
                makeCardLog(s);
                return s;
            })
        }else{
            alert(`Can't find solo play 'Reinforce' card! Report this as a bug.`)
        } 
    }
    if(get(state).campaignInfo && get(state).campaignInfo.startingIncident){
        state.update(s => {
            let inc = s.commons.incidents[0];
            s.commons.incidents = s.commons.incidents.slice(1);
            p.decks.deck = [...p.decks.deck, inc];
            shuffle(p.decks.deck);
            return s;
        })
    }

/*let un = await getUsername();
ui.update(ui => {
    ui.seats.push({
        id: 0,
        uid: getUID(),
        username: un
    });
    return ui;
})*/

    if(get(state).campaignInfo && get(state).campaignInfo.logProper && get(state).campaignInfo.currentRank != 'Ensign'){
        // Mix up reserve/starter decks!
        let reserveSize = p.decks.reserve.length;
        let cards = [...p.decks.reserve, ...p.decks.deck];
        shuffle(cards);
        p.decks.reserve = cards.slice(0, reserveSize);
        p.decks.deck = cards.slice(reserveSize);
    }
}


// Junk/destroy off the top of each market deck for the number of boxes combined.
// Done live through doAction so it shows up in the log and is public for inspection,
// rather than being sliced off silently during setup.
export async function setupJunk(){
    // Games set up before the choice was recorded: work it out as before
    let choice = get(state).setupRemoval || setupRemovalChoice();
    let {junk: numJunk, destroy: numDestroy} = choice;
    if(numJunk == 0 && numDestroy == 0) return;
    let p = get(state).players[0];
    let effects = [];
    if(numJunk) effects.push(`junking ${numJunk}`);
    if(numDestroy) effects.push(`destroying ${numDestroy}`);
    let text = effects.join(' and ');
    if(choice.custom){
        logText(`Custom setup: ${text} from each market deck (rules default for ${choice.mainBoxes.length} main box${choice.mainBoxes.length == 1 ? '' : 'es'}: junk ${choice.auto.junk}, destroy ${choice.auto.destroy})`);
    }else{
        logText(`Combining ${choice.mainBoxes.length} main boxes (${choice.mainBoxes.join(', ')}): ${text} from each market deck`);
    }
    if(numJunk > 0) await removeTopOfEachMarketDeck(p, 'junk', numJunk);
    // Shown to each human player during their setup actions
    let destroyed = numDestroy > 0 ? await removeTopOfEachMarketDeck(p, 'destroy', numDestroy) : [];
    if(destroyed.length > 0){
        state.update(s => {
            s.setupDestroyed = destroyed;
            //s.commons.destroyed = [...s.commons.destroyed, ...s.setupDestroyed];
            return s;
        })
    }
}

export async function starterActions(){
    // Draw starting hands (now that cards are properly set up in log)

    if(!get(state).practice && ongoingPlayer(get(state).players[0]).includes('second_player')){
        // First swap the players
        state.update(s => {
            let temp = s.players[0];
            s.players[0] = s.players[1];
            s.players[1] = temp;
            makeCardLog(s); // to get ownership correct again!
            return s;
        })
    }

    // Before any player setup: campaign reinforcements expect the box junking to have happened
    if(isMe(get(state).players[0]) && get(state).players.some(p => !p.started)) await setupJunk();
    
    while(get(state).players.some(p => !p.started)){
        
        //console.log(p);
        let p = get(state).players[get(state).currentPlayer];
        //await untilQueueEmpties(); // poss?
        if(!isMe(p)){
            await new Promise((resolve, reject) => {
                let unsub = state.subscribe(s => {
                    if(isMe(get(state).players[get(state).currentPlayer])){
                        unsub();
                        resolve(true);
                    }
                    if(!get(state).players.some(p => !p.started)){
                        unsub();
                        resolve(true);
                    }
                })
            });
            await untilQueueEmpties();
            continue;
        }
        if(p.started || p.bot){
            if(p.bot) p.started = true;
            state.update(s => {
                if(s.currentPlayer < s.players.length - 1){
                    s.currentPlayer++;    
                }else{
                    s.currentPlayer = 0;
                }
                s.activePlayer = s.currentPlayer;
                return s;
            })
            continue;
        }
        // Cards destroyed by the combined-market setup: show them to each human player
        if(get(state).setupDestroyed && get(state).setupDestroyed.length > 0){
            let destroyed = get(state).setupDestroyed.map(c => getCard(c)).filter(c => c);
            if(destroyed.length > 0){
                console.log(get(state));
                await chooseCards(`Destroyed from the market decks during setup: press OK to continue`, destroyed, {optional: true, noCard: 'OK', lookSpecific: true});
            }
        }
        if(get(state).campaign && !p.bot){
            await playerCampaignSetup(p); // For 'before hand drawn' actions
        }
        p.handSize = getStarterHandSize(p);
        p.actions = getActionsPerTurn(p);

        if(ongoingPlayer(p).includes('starting_resources')){
            let sr = ongoingPlayer(p, 'starting_resources')[0];
            if(sr.clearOthers){
                p.glory = 0;
                p.dilithium = 0;
                p.latinum = 0;
            }
            for(let r of possArray(sr.amounts)){
                p[r.types] = r.num;
            }
        }

        if(ongoingPlayer(p, 'whim_limit').length > 0){
            p.whim_limit = ongoingPlayer(p, 'whim_limit')[0];
        }

        if(ongoingPlayer(p).includes('acquisition_rules')) setupAcquisitionRules(p);
        let extraHand = 0;
        // Campaign reward possibilities
        // Below commented out test rig
        /*if(get(state).campaignInfo){
            state.update(s => {
                s.campaignInfo.games = [
                    {
                        reward: {
                            type: 'gain',
                            gain: 'latinum',
                            amount: 2
                        }
                    },
                    {
                        reward: {
                            type: 'extra_draw',
                            gain: 'latinum',
                            amount: 2
                        }
                    },
                    {
                        reward: {
                            type: 'away_team',
                            gain: 'latinum',
                            amount: 1
                        }
                    },
                    {
                        reward: {
                            type: 'gain',
                            gain: 'research',
                            amount: 3
                        }
                    },
                    {
                        reward: {
                            type: 'add_common',
                            card: {
                                name: 'Plasma Manifold',
                                id: '1CARG14/16'
                            }
                        }
                    },
                    {
                        reward: {
                            text: 'When you would gain or scan for [[cargo]] or [[ally]] add "including from junk"',
                            type: 'from_junk',
                            filter: ['cargo', 'ally']
                        }
                    },
                    {
                        reward: {
                            text: 'When you would gain a [[person]] or [[ship]] you may pay 1 [[latinum]] to gain from junk instead',
                            type: 'from_junk',
                            filter: ['person', 'ship'],
                            cost: [
                                {
                                type: 'spend',
                                resource: 'latinum',
                                num: 1
                                }
                            ]
                        }
                    },
                    {
                        reward: {
                            type: 'discard_reinforcement',
                            amount: 1
                        }
                    }
                ];
                return s;
            })
            
        }*/
        if(get(state).campaign && get(state).campaignInfo){
            for(let g of get(state).campaignInfo.games){
                if(g.reward){
                    if(g.reward.type == 'gain'){
                        let gain = g.reward.gain;
                        if(Array.isArray(g.reward.gain)){
                            gain = await choose(`Campaign reward: gain ${g.reward.amount} of:`, g.reward.gain.map(g => `[[${g}]]`));
                            gain = g.reward.gain.find(g => gain == `[[${g}]]`);
                        }
                        p[gain] += g.reward.amount;
                    }else if(g.reward.type == 'extra_draw'){
                        extraHand += g.reward.amount;
                    }else if(g.reward.type == 'away_team'){
                        let card = await chooseCards(`Campaign reward: choose a location to to send an [[away team]] to`, [...getNeutralZone()]);
                        await doAction(p, 'away', {obj: {num: g.reward.amount}, on: [card.uniqueID]});
                    }else if(g.reward.type == 'log'){
                        let card = await chooseCards(`Campaign reward: choose a card to log`, [...p.decks.deck, ...p.decks.reserve], {lookSpecific: true});
                        await doAction(p, 'log', {obj: card.uniqueID});
                    }else if(g.reward.type == 'choose_starter'){
                        let card = await chooseCards(`Campaign reward: choose ${g.reward.amount} card(s) for your starting hand`, [...p.decks.deck, ...p.decks.discard], {lookSpecific: true, number: g.reward.amount});
                        //p.decks.hand = [...p.decks.hand, ...card];
                        //p.decks.deck = p.decks.deck.filter(c => !card.some(cd => c.uniqueID == cd.uniqueID));
                        for(let c of card){
                            await doAction(p, 'draw', {obj: c.uniqueID});
                        }
                        extraHand -= g.reward.amount;
                    }else if(g.reward.type == 'free_play'){
                        let card = await chooseCards(`Campaign reward: choose a [[${g.reward.filter}]] to free play`, [...p.decks.deck], {lookSpecific: true});
                        if(card && card != 'cancelled') await doAction(p, 'freeplay', {obj: card.uniqueID});
                    }else if(g.reward.type == 'discard_reinforcement'){
                        let card = await chooseCards(`Campaign reward: choose a card from Reinforcements to place in discard`, [...p.decks.reinforcements], {lookSpecific: true, cancellable: true});
                        if(card && card != 'cancelled'){
                            await doAction(p, 'discard', {obj: card.uniqueID});
                        }
                    }else if(g.reward.type == 'from_junk'){
                        /*text: 'When you would gain a [[person]] or [[ship]] you may pay 1 [[latinum]] to gain from junk instead',
            type: 'from_junk',
            filter: ['person', 'ship'],
            cost: [
                {
                    type: 'spend',
                    resource: 'latinum',
                    num: 1
                }
                ]*/
                        if(!p.from_junk) p.from_junk = [];
                        p.from_junk.push(g.reward);
                        await choose(`Campaign reward: ${g.reward.text}`, ['OK']);
                    }else if(g.reward.type == 'gain_when_junk'){
                        if(!p.gain_junk) p.gain_junk = [];
                        p.gain_junk.push(g.reward);
                        await choose(`Campaign reward: ${g.reward.text}`, ['OK']);
                    }else if(g.reward.type == 'reinforce_boost'){
                        if(!p.reinforce_boost) p.reinforce_boost = [];
                        p.reinforce_boost.push(g.reward);
                        await choose(`Campaign reward: ${g.reward.text}`, ['OK']);
                    }
                } 
            }
        }

        // ongoing starter actions
        let savedCache = get(state).cache;
        state.update(s => {
            if(!s.cache) s.cache = {};
            s.cache.setupActions = true;
            return s;
        })

        /*if(['setup_actions', 'prehand_actions'].some(a => ongoingPlayer(p).includes(a))){
            await choose(`About to take pre-game actions for ${p.captain}: click OK when ready to continue (in case you wish to look at market/Junk setup first)`, ['OK']);
        }*/


        for(let c of [...allScoreableCards(p), ...(p.dashboard.passives || [])]){ // was cardsInPlay
            if(ongoingEffects(c).includes('setup_actions')){
                for(let e of ongoingEffects(c, 'setup_actions')){
                    await resolveEffects(c, e, e.attack);
                }
            }
        }

        
        
        // This is separate because some say specifically AFTER setup but BEFORE drawing hand
        for(let c of [...allScoreableCards(p), ...(p.dashboard.passives || [])]){
            if(ongoingEffects(c).includes('prehand_actions')){
                for(let e of ongoingEffects(c, 'prehand_actions')){
                    await resolveEffects(c, e, e.attack);
                }
            }
        }
        
        state.update(s => {
            s.cache = savedCache;
            return s;
        })

        
        let hs = await handSize(p);
        state.update(s => {
            s.players[s.currentPlayer].currentHandSize = hs;
            return s;
        })
        //await doAction(p, 'draw', {num: hs});
        let toDraw = (hs + extraHand) - p.decks.hand.length; // In case you drew some already
        if(toDraw > 0) await drawCard(p, toDraw, {noPause: true});
        /*p.decks.hand = p.decks.deck.slice(0, hs);
        p.decks.deck = p.decks.deck.slice(hs);*/

        // Any 'after drawing starter hand' actions
        if(get(state).campaign && get(state).campaignInfo){
            for(let g of get(state).campaignInfo.games){
                if(g.reward){
                    if(g.reward.type == 'starter_gain_junk'){
                        for(let i = 0; i < g.reward.num; i++){
                            let choose = await chooseCards(`Campaign reward: choose a card to gain from junk`, [...get(state).commons.junk], {cancellable: true})
                            if(!choose || choose == 'cancelled') break;
                            await doAction(p, 'gain_card', {obj: choose.uniqueID});
                        }
                    }else if(g.reward.type == 'boost' && g.reward.timing == 'after'){
                        logText(`Campaign Reward: ${g.reward.text}`);
                        await resolveEffects(p.captain, g.reward.effect, g.reward.attack);
                    }
                } 
            }
        }
        p.started = true;
        
        state.update(s => {
            if(s.currentPlayer < s.players.length - 1){
                s.currentPlayer++;    
            }else{
                s.currentPlayer = 0;
            }
            s.activePlayer = s.currentPlayer
            return s;
        })

        if(!isMe(get(state).currentPlayer)) await untilQueueEmpties(); // Jan 2026 added to ensure we are up to date first
        updateState(true); // To pass over to next player

        // forced update for passing over
    }
}

export async function makeReadyForPlay(){
    ui.update(u => {
        u.viewing = 0;
        u.seat = 0;
        //u.advertiseGame = get(prefs).advertiseGames;
        return u;
    })

    if(get(ui).seats.length == 0){
        let un = await getUsername();
        for(let p of get(state).players){
            p.username = un;
            ui.update(ui => {
                ui.seats.push({
                    id: 0,
                    uid: getUID(),
                    username: un
                });
                return ui;
            })
        } 
    }
}

function addBeamed(state, c, p){
    if(!c.beamed || c.beamed.length == 0) return;
    for(let b of c.beamed){
        b.sourcePlayer = p;
        state.cardLog[b.uniqueID] = {
            area: 'beamed',
            deck: `${c.uniqueID}`
        }
    }
}

function makeCardLog(state){
    // TODO handle beamed cards??
    for(let k of Object.keys(state.commons)){
        for(let i = 0; i < state.commons[k].length; i++){
            let c = state.commons[k][i];
            state.cardLog[c.uniqueID] = {
                area: 'commons',
                deck: k
            };
            addBeamed(state, c, -1);
        }
    }
    for(let i = 0; i < state.players.length; i++){
        for(let k of Object.keys(state.players[i].decks)){
            for(let j = 0; j < state.players[i].decks[k].length; j++){
                let c = state.players[i].decks[k][j];
                state.cardLog[c.uniqueID] = {
                    area: 'players',
                    player: i,
                    deck: k
                };
                addBeamed(state, c, i);
            }
        }
        let dash = state.players[i].dashboard;
        for(let c of dash.missions){
            //console.log('making dashboard log', c);
            state.cardLog[c.uniqueID] = {
                area: 'player_dashboards',
                player: i,
                deck: 'missions'
            }
        }
        for(let c of dash.passives){
            state.cardLog[c.uniqueID] = {
                area: 'player_dashboards',
                player: i,
                deck: 'passives'
            }
        }
    }
    //console.log('finished card log', state.cardLog);
}

function getStarterHandSize(p){
    if(ongoingPlayer(p, 'hand_size').length > 0) return ongoingPlayer(p, 'hand_size')[0];
    return 5;
}

export function getActionsPerTurn(p){
    if(ongoingPlayer(p, 'action_limit').length > 0) return ongoingPlayer(p, 'action_limit')[0];
    return 3;
}


async function setupPlayer(p, cards, i){
    //console.log('setting up ',p)

    let allCards = cards;
    
    let missions = [];/*cards.filter(c => c.deck == p.captain && c.suits.includes('mission')).map(c => genCard(c));
    if(get(state).gameType == 'advanced'){
        missions = missions.filter(c => !c.id.includes('basic_missions'));
    }else{
        missions = missions.filter(c => c.id.includes('basic_missions'));
    }*/ // No mission cards outside of dashboard now
    p.username = get(prefs).username;
    cards = cards.filter(c => c.deck == p.captain);
    if(p.bot){
        cards = cards.filter(c => !c.suits.includes('status')); // Replaces later bit now that status can be outside of deck (e.g. Riker)
    }

    if(get(res).modules.includes('Treachery')){
        // add the backstabbing card
        let backstabbing = allCards.find(c => c.id == '5DIR01/1');
        if(backstabbing){
            cards = [...cards, backstabbing];
        }else{
            alert('Unable to find Treachery-specific Backstabbing or Loyalty? Directive – check ID number (should be 5DIR01/1)');
            //console.log(cards.filter(c => c.id.startsWith('5')));
        }
    }

    if(p.bot){
        let tokenlessShips = cards.filter(c => c.suits.includes('ship') && (!c.ships || c.ships.length == 0));
        console.log('Adding tokens to tokenless ships:', tokenlessShips);
        for(let c of tokenlessShips){
            c.ships = [`_generic_ship_${c.id}`];
        }
        // set up stardate cards
    }
    let startsOut = cards.filter(c => c.area == 'Deployed' || c.suits.includes('status') && !c.area).map(c => genCard(c));
    let controlled = cards.filter(c => c.area == 'Controlled').map(c => genCard(c));
    let logCards = cards.filter(c => c.area == 'Logged').map(c => genCard(c));
    cards = cards.filter(c => !startsOut.some(cd => c.id == cd.id));
    cards = cards.filter(c => c.area != 'Supply'); // These are handled separately
    let discard = cards.filter(c => c.area == 'Discard').map(c => genCard(c));
    cards = cards.filter(c => c.area != 'Discard');
    let dev = cards.filter(c => c.area == 'Development').map(c => genCard(c));
    let reserve = cards.filter(c => c.area == 'Reserve').map(c => genCard(c));
    let duty = cards.filter(c => c.area == 'Duty').map(c => genCard(c));
    let deck = cards.filter(c => c.area == 'Starter').map(c => genCard(c));
    let rewards = cards.filter(c => c.area == 'REWARDS').map(c => genCard(c));
    let beamed = cards.filter(c => c.area == 'Beamed').map(c => genCard(c));
    let opponent = cards.filter(c => c.area && c.area.startsWith('opponent ')).map(c => genCard(c));
    
    if(p.bot){

        if(get(res).modules.includes('Badlands')){
            // Add hiding plasma storms card
            let haps = get(res).cards.find(c => c.area == 'SOLO ONLY' && c.name.toLowerCase().trim() == 'hiding amongst plasma storms');
            deck = [...deck, genCard(haps)];
        }
        for(let k of Object.keys(get(state).soloChallenge)){
            if(get(state).soloChallenge[k]){
                let card = get(res).cards.find(c => c.area == 'SOLO CHALLENGE' && c.name == k);
                let pct = get(res).parsedCardText[card.id];
                if(JSON.stringify(pct).includes('starts_in_your_reserve')){
                    // Hacky but should work: put it in *your* reserve
                    // (since bot always goes second it should be ok...?)
                    let o = get(state).players.find(pl => pl.captain != p.captain);
                    if(o.decks && o.decks.reserve){
                        o.decks.reserve = [...o.decks.reserve, genCard(card)];
                        shuffle(o.decks.reserve);
                    }
                }else{
                    deck = [...deck, genCard(card)];
                }
            }
        }
    }
    
    /*if(p.bot && get(state).useConspiracy){
        let conspiracy = get(res).cards.find(c => c.area == 'SOLO CHALLENGE' && c.name.toLowerCase().trim() == 'conspiracy');
        deck = [...deck, genCard(conspiracy)];
    }*/
    let captain = cards.filter(c => c.suits.includes('captain') && !c.id.includes('B/')).map(c => genCard(c)); // Don't include any reverse sides
    shuffle(reserve);
    shuffle(deck);
    let hand = [];
    let reinforcements = [];
    //let dynasty = [];
    if(p.bot){
        
    }else{
        /*if(get(prefs).customHandSize){
            hand = deck.slice(0, get(prefs).starterHandSize);
            deck = deck.slice(get(prefs).starterHandSize);
            p.handSize = get(prefs).normalHandSize;
        }else{
            p.handSize = getStarterHandSize(captain[0]);
            hand = deck.slice(0, p.handSize);
            deck = deck.slice(p.handSize);
        }*/
    }  
    if(get(state).practice && i != 0){
        dev = reserve = deck = hand = captain = missions = [];
        // add dummy hand too
        startsOut = [{
            name:'Dummy ship',
            uniqueID: -2,
            allText: '',
            area: 'Starter',
            deck: '',
            id: 'DUMMY',
            suits: ['ship'],
            values: [],
            ships: [],
            stats: {},
            traits: [],
        }]

        duty = [{
            name:'Dummy Duty Officer',
            uniqueID: -3,
            allText: '',
            area: 'Starter',
            deck: '',
            id: 'DUMMY',
            suits: ['person'],
            values: [],
            ships: [],
            stats: {},
            traits: ['wildcard'],
        }]
    }
    
    p.decks = {
        dev,
        reserve,
        deck,
        hand,
        captain,
        discard,
        cleanup: [],
        duty,
        reinforcements,
        locations: [...controlled, ...startsOut.filter(c => c.suits.includes('location'))],
        fleet: startsOut.filter(c => !c.suits.includes('location') && !c.suits.includes('person')), // was c.suits.includes('ship') || c.suits.includes('cargo')),
        missions,
        journey: [],
        //completed_missions: [],
        play: [],
        log: logCards,
        rewards,
        opponent
    };

    if(beamed.length > 0){
        if(p.bot && p.captain == 'Dal & Gwyn'){
            shuffle(beamed);
            p.decks.deck = [...p.decks.deck, ...beamed]; // as per special rule
        }else{
            let possBeamHolders = [...p.decks.fleet, ...p.decks.locations];
            let holder = possBeamHolders[0];
            if(possBeamHolders.length == 0){
                alert('Error: nowhere to beam beamed starter cards – putting into discard instead');
                p.decks.discard = [...beamed, ...p.decks.discard];
            }else{
                if(!holder.beamed) holder.beamed = [];
                holder.beamed = [...holder.beamed, ...beamed];
                if(possBeamHolders.length > 1){
                    alert('Warning: more than one possible location for beamed starter card – fix wording');
                }
            }
        }
        
    }

    if(!p.bot){
        p.dilithium = 1;
        p.latinum = 1;
        p.glory = 1;
        //p.dashSide = get(state).gameType;
        if(p.dashSide == 'journey'){
            p.dashSide = 'advanced';
            if(p.captain == 'Janeway'){
                p.journeyModule = true;
            }
        }
    }else{
        p.dilithium = 0;
        p.latinum = 0;
        p.glory = 0;
        p.dashSide = 'basic';
        if(p.captain == 'Khan') p.currentChart = 'exile'; // Khan starts in exile
        if(p.captain == 'Shaw') p.currentChart = 'shaw';
    }    

    p.military = 0;
    p.research = 0;
    p.influence = 0;


    if(get(res).shorterTurns) p.actions = 2;
    p.activations = get(prefs).numActivations;
    let prefix = '';
    if(p.dashSide == 'basic' || p.bot) prefix = '_basic';
    p.dashboard = clone(get(res).dashboards[p.captain+prefix]);
    if(p.bot && p.dashboard.missions && p.dashboard.missions.length > 0){
        p.dashboard.missions[0].complete = true;
    }
    for(let m of [...(p.dashboard.missions || []), ...(p.dashboard.passives || [])]){
        m.uniqueID = getUniqueID();
    }

    if(p.captain == 'Borg Queen'){
        delete p.military;
        delete p.research;
        delete  p.influence;
        p.collective = 0;
        //delete p.decks.log;
        p.decks.assimilated = [];
        //p.decks.captain[0].allText += ' '+borgPassives().replaceAll(`\n`, ' ');
        //await parseCards([p.decks.captain[0]], true);
    }else if(p.captain == 'Khan'){
        p.collected_traits = [];
    }else if(p.captain == 'Q'){
        delete p.military;
        delete p.research;
        delete  p.influence;
        p.whim = 0;
        p.whim_limit = 16; // max is 15
        if(!p.bot){
             let continuum = allCards.filter(c => c.deck == p.captain && (c.area == 'Continuum' || c.area == 'Missions')).map(c => genCard(c));
            let startingContinuum = continuum.filter(c => c.starting_mission);
            let otherContinuum = continuum.filter(c => !c.starting_mission);
            shuffle(startingContinuum);
            shuffle(otherContinuum);
            let accepted = startingContinuum.slice(0, 2);
            startingContinuum = startingContinuum.slice(2);
            continuum = [...accepted, ...startingContinuum, ...otherContinuum];
            //shuffle(continuum);
            //continuum = [...accepted, ...continuum];
            //let voidCards = allCards.filter(c => c.deck == p.captain && c.area == 'Void').map(c => genCard(c));
            p.decks = {
                ...p.decks,
                continuum,
                //void: voidCards // for now
            };

            // set up judgement step
            p.judgment_effects = pegParse(`Gain 1 [[whim]] for each card in your hand. Discard any number of cards from your hand. For each card in your Staging Area, either: spend 1 [[whim]] to snap it OR log it to gain an [[action]] OR put it in your Discard pile. Then, you may spend 4 [[whim]] and destroy a non-[[incident]] card from your Log to shuffle your Discard pile into your Draw deck.`)
        }
    }else if(p.captain == 'Dal & Gwyn'){
        p.decks.captain[0].murf = true; // Give them murf to start with
    }else if(p.captain == 'Janeway'){
        if(p.journeyModule){
            for(let m of p.dashboard.missions){
                m.traits = ['journey'];
            }
        }else{
            p.decks.fleet = p.decks.fleet.filter(c => !c.traits.includes('journey')); // for status card
            p.decks.rewards = p.decks.rewards.filter(c => !c.traits.includes('journey')); // for missions
        }
        /*if(p.dashSide == 'advanced'){
            p.dashboard.missions = [];
            let journey = allCards.filter(c => c.deck == p.captain && c.traits.includes('journey')).map(c => genCard(c)).sort((a,b) => a.id.localeCompare(b.id));
            console.log(journey);
            missions = [...missions, ...journey.slice(0, 1)];
            journey = journey.slice(1);
            p.decks = {
                ...p.decks,
                journey,
                missions
            };
            //p.decks.captain[0].allText += ' '+janewayPassives().replaceAll(`\n`, ' ');
            //await parseCards([p.decks.captain[0]], true);
        }else{
            // Remove The Journey Home card
            p.decks.fleet = p.decks.fleet.filter(c => c.name.toLowerCase() != 'the journey home');
        }*/
    }
    
    p.ongoing = [];
    p.hangingEffects = [];
    p.stats = {
        cardsGained: {},
        activationsPerTurn: []
    }
    p.score = 0;
    p.stardateCards = [];

    if(p.bot){
        //p.decks.dynasty = dynasty;
        startsOut = [...startsOut, ...controlled];
        shuffle(startsOut);
        p.decks.locations = [];
        p.decks.fleet = [];
        p.decks.deck = [...startsOut, ...p.decks.deck];
        shuffle(p.decks.dev);
        if(p.captain == 'Khan'){
            // put Genesis Device on bottom
            p.decks.deck = p.decks.deck.filter(c => !matches(c, 'ceti alpha v') && !matches(c, 'ceti alpha vi'));
            p.decks.dev = [...p.decks.dev.filter(c => !matches(c, 'genesis device')), ...p.decks.dev.filter(c => matches(c, 'genesis device'))];
        }
        //dev = dev.sort((a,b) => botValue(b, p, true) - botValue(a, p, true));
        p.decks.reserve = [...p.decks.reserve, ...p.decks.dev];
        p.decks.dev = []; // For simplicity
        p.stats.botActions = {};
        if(p.captain == 'Culluh'){
            p.decks.captain[0].away_teams.Culluh = 0; // starts with 0 AT
        }
    }else{
        if(ongoingPlayer(p).includes('crossover')){
            p.decks.crossover = makeCrossoverDeck(allCards);
        }
    }
}


let practiceSDs = [
    {
      ref: 1,
      glory: 5,
      eventText: `At the beginning of the next player's Clean-up Step, wipe the market (removing all Glory) and any neutral [[location]] with no [[ship]]/Away Team.`,
      event: 'wipe_all'
    },
    {
      ref: 2,
      glory: 5,
      eventText: `Trigger end game.`,
      event: 'end_game'
    }
  ]

function makeCrossoverDeck(cards){
    let captains = cards.filter(c => c.suits.includes('captain') && !get(state).players.some(p => p.captain.includes(c))).filter(c => !c.traits.includes('borg'));
    shuffle(captains);
    console.log(captains);
    let cap = captains[0];
    let possibleCrossovers = captains.map(cap => {
        let crossover = cards.filter(c => c.deck == cap.deck && c.suits.includes('person') && (c.area == 'Starter' || c.area == 'Reserve'));
        return crossover;
    })
    //shuffle(possibleCrossovers);
    //console.log('Crossover deck:', crossover)
    console.log('All possible crossovers:', possibleCrossovers);
    return possibleCrossovers[0].map(c => genCard(c));
}

function getRuleNumber(c){
    let num = c.name.match(/\#[0-9]+/);
    if(num) num = parseInt(num.slice(1));
    if(!num) return Infinity
    return num;
}

function setupAcquisitionRules(p){
    let rules = p.decks.fleet.filter(c => c.traits.includes('rule of acquisition'));
    p.decks.fleet = p.decks.fleet.filter(c => !rules.includes(c));
    shuffle(rules);
    let chosen = rules.slice(0, 3).sort((a,b) => getRuleNumber(a) - getRuleNumber(b));
    chosen[0].active = true;
    chosen[1].inactive = true;
    chosen[2].inactive = true;
    p.decks.fleet = [...chosen, ...p.decks.fleet];
}

function setupStardates(){
    let sc;
    if(get(state).practice){
        sc = clone(get(res).allStardates.filter(s => s.mode == 'Solo Cadet Practice'));
    }else if(get(state).players.some(p => p.bot)){
        let bot = get(state).players.find(p => p.bot);
        sc = clone(get(res).allStardates.filter(s => s.mode == `Solo vs ${bot.botLevel.split(' ')[0]} Bot`));
    }else{
        sc = clone(get(res).allStardates.filter(s => s.mode == '2-player'));
        if(get(res).shorterTurns){
            for(let card of sc){
                card.glory = Math.floor(card.glory * 1.5);
            }
        }
    }

    // Look for modules
    let modSpecific = sc.filter(c => c.module);
    sc = sc.filter(c => !c.module);

    for(let m of get(res).modules){
        let selectedMods = modSpecific.filter(c => c.module == m);
        for(let mod of selectedMods){
            // sub in
            let i = sc.findIndex(c => c.sequence == mod.sequence);
            sc[i] = mod; // replace!
        }
    }

    state.update(s => {
        s.stardateCards = sc;
        return s;
    })
}

function removeDuplicates(cards){
    let filteredCards = [];
    let collator = new Intl.Collator('en', {numeric: true})
    cards = cards.sort((a,b) => collator.compare(b.id, a.id)); // Reverse set order
    for(let c of cards){
        if(filteredCards.some(cd => cd.name == c.name)) continue;
        filteredCards = [...filteredCards, c];
    }
    return filteredCards;
}

// Boxes in play: the commons selection plus anything mixed in.
function boxesInPlay(){
    return [...get(res).selectedCommons, ...Object.keys(get(res).mixinSets || {})];
}

// A 'main box' is a big box (Core Set, To Boldly Go, Resistance is Futile, Dominion War...),
// marked 'Base' in the Box Type column of the _Sets sheet. Small expansions and promo packs
// (Duty & Honor, Second Contact...) don't count towards setup junking/destruction.
export function isMainBox(name, sets = get(res).sets){
    let box = sets.find(s => s.name == name);
    return !!box && box.type == 'Base';
}

export function mainBoxesInPlay(){
    return boxesInPlay().filter(b => isMainBox(b));
}

// Setup junking/destruction per market deck, by how many main boxes are combined.
// Now: destroy 1 per main box beyond the first; small expansions don't count.
export function boxSetupCounts(boxes){
    return {
        junk: 0,
        destroy: Math.max(boxes - 1, 0)
    };
}

// What setupJunk() will do, fixed at setup and kept in the game state (so it's in the save
// and stats can see it). res.setupJunk / res.setupDestroy are the setup screen's overrides;
// null means use the rules default.
export function setupRemovalChoice(){
    let mainBoxes = mainBoxesInPlay();
    let auto = boxSetupCounts(mainBoxes.length);
    let pick = (override, def) => (override === null || override === undefined || override === '') ? def : Math.max(parseInt(override) || 0, 0);
    let junk = pick(get(res).setupJunk, auto.junk);
    let destroy = pick(get(res).setupDestroy, auto.destroy);
    return {
        boxes: boxesInPlay(),
        mainBoxes,
        auto,
        junk,
        destroy,
        custom: junk != auto.junk || destroy != auto.destroy
    };
}

function setupMarket(state, cards){

    let allCards = [...cards];

    /*if(state.practice){
        state.stardateCards = clone(get(res).allStardates.filter(s => s.mode == 'Solo Cadet Practice'));//clone(practiceSDs); //clone(r.allStardates.filter(s => !s.notPractice));
    }else if(state.players.some(p => p.bot)){
        let bot = state.players.find(p => p.bot)
        state.stardateCards = clone(get(res).allStardates.filter(s => s.mode == `Solo vs ${bot.botLevel.split(' ')[0]} Bot`));
    }else{
        state.stardateCards = clone(get(res).allStardates.filter(s => s.mode == '2-player'));
        if(get(res).shorterTurns){
            for(let sc of s.stardateCards){
                sc.glory = Math.floor(sc.glory * 1.5);
            }
        }
    }*/
    setupStardates();

    console.log('stardates', sdCards(), get(res).allStardates);

    let r = cards.find(c => c.name == 'Redshirt');
    let redshirts = [];
    if(r){
        for(let i = 0; i < 6; i++){
            redshirts.push(genCard(r));
        }
    }

    cards = cards.filter(c => c.name != 'Redshirt');

    cards = cards.filter(c => get(res).selectedCommons.includes(c.box));

    
    if(get(res).mixinSets){
        let cardsToAdd = [];
        for(let k of Object.keys(get(res).mixinSets)){
            cardsToAdd = [...cardsToAdd, ...allCards.filter(c => c.box == k)];
        }
        cards = [...cards, ...cardsToAdd];
    }


    let rewards = cards.filter(c => c.area == 'REWARDS' && ['Common', 'Locations'].includes(c.deck)).map(c => genCard(c));
    cards = cards.filter(c => c.area != 'REWARDS');

    let locations = cards.filter(c => c.deck == 'Locations').map(c => genCard(c));
    locations = removeDuplicates(locations);
    let starterLocations = locations.filter(c => c.area == 'Starting Location');
    let otherLocations = locations.filter(c => c.area == 'Advanced Location');
    
    shuffle(starterLocations);
    shuffle(otherLocations);
    let availableStarters = starterLocations.slice(0, get(prefs).starterLocations);
    if(get(res).krulmuth && !availableStarters.some(c => c.name.startsWith('Krulmuth'))){
        let krulmuth = get(res).cards.find(c => c.name.startsWith('Krulmuth'));
        if(krulmuth){
            availableStarters = [genCard(krulmuth), ...availableStarters.slice(1)];
            shuffle(availableStarters);
        }
    }
    locations = [...availableStarters, ...otherLocations];
    if(state.practice && state.players[0].captain == 'Borg Queen'){
        let starter = starterLocations.find(l => !availableStarters.includes(l)) || availableStarters.pop();
        let adv = otherLocations.pop();
        state.practiceOppLocations = [starter, adv];
    }

    let neutral_zone = [...locations.slice(0, get(res).cardsInNeutralZone)];
    if(get(res).modules.includes('Badlands') && !cards.some(c => isBadlands(c))){
        // Add to game
        let bs = get(res).cards.filter(c => isBadlands(c));
        cards.push(...bs);
    }
    if(cards.some(c => isBadlands(c))){
        neutral_zone = [...neutral_zone, genCard(cards.find(c => isBadlands(c) /*&& (c.id.includes('B') || !state.players[1].bot)*/))]; // Only 1 Badlands now
        //locations = locations.filter(c => c.name.toLowerCase() != 'badlands');
    }
    locations = locations.slice(get(res).cardsInNeutralZone);

    for(let c of [...neutral_zone]){
        c.entered = {
            turn: 0,
            location: 'neutral_zone'
        }
        if(state.practice){
            c.away_teams = {};
            c.away_teams[state.players[1].captain] = 1;
        }
    }

    let reverseCards = get(res).cards.filter(c => c.area == 'BACK').map(c => genCard(c));

    let supplyIncidents = cards.filter(c => state.players.some(p => c.deck == p.captain) && c.area == 'Supply' && c.suits.includes('incident')).map(c => genCard(c));

    cards = cards.filter(c => c.deck == 'Common'); // To get rid of player-specific cards from below

    if(get(res).selectedCommons.length > 1){
        /*// remove duplicates
        cards = cards.filter(c => c.id && !c.id.endsWith('•'));
        // remove originals for replacements
        let replacements = cards.filter(c => c.id && c.id.endsWith('†'));
        for(let r of replacements){
            //let origID = r.id.slice(0, -1);
            cards = cards.filter(c => c.name != r.name || c.id.endsWith('†'));
        }*/

        // New, simpler general algorithm to remove duplicates:
        // Ignore all the bullet point stuff and just filter out older versions
        cards = removeDuplicates(cards);
    }

    let encounters = cards.filter(c => c.suits.includes('encounter')).map(c => genCard(c));;
    shuffle(encounters);
    //encounters = encounters.slice(0, 7); // No longer remove one!

    let marketIncidents = cards.filter(c => c.suits.includes('incident')).map(c => genCard(c));
    shuffle(marketIncidents);
    if(marketIncidents.length > 6) marketIncidents = marketIncidents.slice(0, 6);

    let incidents = [...supplyIncidents, ...marketIncidents];
    shuffle(incidents);

    if(get(prefs).separateMarkets){
        let cargo = cards.filter(c => c.suits.includes('cargo')).map(c => genCard(c));
        let allies = cards.filter(c => c.suits.includes('ally')).map(c => genCard(c));
        let ships = cards.filter(c => c.suits.includes('ship')).map(c => genCard(c));
        let people = cards.filter(c => c.suits.includes('person')).map(c => genCard(c));
        shuffle(cargo);
        shuffle(allies);
        shuffle(ships);
        shuffle(people);
        
        // Box-count junking/destruction happens live in setupJunk(), so it lands in the log

        for(let c of [...cargo.slice(0, 1), ...allies.slice(0, 1), ...ships.slice(0, 1), ...people.slice(0, 1)]){
            c.entered = {
                turn: 0,
                location: 'market'
            }
        }

        state.commons = {
            //missions, 
            encounters,
            locations,
            neutral_zone,
            allies,
            cargo,
            ships,
            people,
            incidents,
            redshirts,
            junk: [],
            destroyed: reverseCards // To swap in and out later
        }

        if(rewards.length > 0){
            state.commons.rewards = rewards;
        }

    }else{
        let market = cards.filter(c => (c.suits.includes('ally') || c.suits.includes('cargo') || c.suits.includes('person') || c.suits.includes('ship'))).map(c => genCard(c));;
        shuffle(market);
        let market_zone = [...market.slice(0, 4)];
        market = market.slice(4);

        for(let m of market_zone){
            m.entered = {
                turn: 0,
                location: 'market'
            }
        }

        state.commons = {
            //missions, 
            encounters,
            locations,
            neutral_zone,
            market,
            market_zone,
            incidents,
            redshirts,
            junk: [],
            destroyed: []
        }
    }

    return state;
}

let newInfo;

export function infoRevealed(){
    newInfo = true;
}

function logStats(p, type, params){
    if(type == 'play_activate') type = params.actionDone || type;
    if(params.exactType) type = `${type}_${params.exactType}`;
    if(params.card){
        let c = getCard(params.card);
        if(c){
            if(!c.stats) c.stats = {};
            if(!c.stats[type]) c.stats[type] = 0;
            c.stats[type]++;
            if(get(state).resolvingFrom){
                p = cardOwner(getCard(get(state).resolvingTo)); // To handle displaced effects
            }else{
                p = cardOwner(c);
            }
        }
    }
    if(params.obj){
        let o = params.obj;
        if(!Array.isArray(params.obj)) o = [o].flat(2);
        for(let obj of o){
            if(typeof obj == 'number'){
                let c = getCard(obj);
                if(c){
                    if(!c.stats) c.stats = {};
                    if(!c.stats.obj) c.stats.obj = {};
                    if(!c.stats.obj[type]) c.stats.obj[type] = 0;
                    c.stats.obj[type]++;
                }
            }
        }
    }
    if(p){
        if(!p.stats.turns[get(state).turn]) p.stats.turns[get(state).turn] = {};
        if(!p.stats.turns[get(state).turn][type]) p.stats.turns[get(state).turn][type] = 0;
        p.stats.turns[get(state).turn][type]++;
        if(params.attack){
            console.log('Attack was played!', p.captain)
            if(!p.stats.turns[get(state).turn].attack) p.stats.turns[get(state).turn].attack = 0;
            p.stats.turns[get(state).turn].attack++;
            //console.log(p.stats.turns[get(state).turn].attack)
        }
    }
}

export async function doAction(p, type, params = {}){
    const endDoAction = perfStart('action.doAction', {type});
    newInfo = false;
    //console.log('doing action', type, params);
    // Was cloning to avoid BvB duplication
    // but that makes reactions fail!
    //params = clone(params);
    p = get(state).players.find(pl => pl.captain == p.captain); // just in case of sync issues
    let pNumber = get(state).players.findIndex(pl => pl.captain == p.captain);
    let newEntry = {
        event: 'action',
        p: pNumber,
        type,
        params
    };

    let savedState;
    if(!get(res).BvB){
        savedState = perfMeasure('action.snapshotState', () => clone(get(state)), {type});
    }else{
        savedState = get(state);
    }

    let compound = false;
    let logIndex = -1;
    let logKey = 'log';

    let action = allActions.find(a => a.type == type);
    console.log(action)
    if(!action){
        endDoAction({type, result: false, reason: 'missing action'});
        return false;
    }
    if(params.obj && getCard(scalarIfOne(params.obj)) && ongoingEffects(getCard(scalarIfOne(params.obj))).includes('cannot_'+type)){
        // Shouldn't be able to do this!
        logText(`Cannot ${type} ${cc(getCard(scalarIfOne(params.obj)))}: abandoning`);
        ui.update(ui => {
            delete ui.per;
            return ui;
        })
        throw 'uncompleted';
    }
    if(action.log){
        if(!Array.isArray(get(state).workingLog)){
            compound = true;
            openWorkingLog();
        }
        console.log('logging')
        // A working log is always open by this point, so log() appends there,
        // whether or not this call is the one that opened it.
        logKey = 'workingLog';
        logIndex = log(newEntry);
    }

    let result = false;
    
    try{

        setHidden(type, params); // to set whether cards display as hidden or not in MP

        console.log('[doAction] before', p, type, params);

        if(type == 'log' && params.obj){
            let target = getCard(scalarIfOne(params.obj));
            if(target){
                let ongoing = ongoingPlayer(p);
                if((ongoing.includes('log_assimilate_or_destroy') && !matches(target, ['location', 'mission'])) ||
                    (ongoing.includes('assimilate_locations_missions') && matches(target, ['location', 'mission']))){
                    params.noReactions = true;
                }
            }
        }

        const endTakeAction = perfStart('action.takeAction', {type});
        try{
            result = await takeAction(p, type, params);
        }finally{
            endTakeAction({type, result});
        }

        console.log('[doAction] after', p, type, params);

        setHidden(type, params); // to set whether cards display as hidden or not in MP
        
        if(action.log && action.log(params) && logIndex != -1){
            // Stringify
            let key = logKey;
            if(get(state)[key] && get(state)[key][logIndex]){
                state.update(s => {
                    s[key][logIndex] = stringifyLogItem(s[key][logIndex], logIndex > 0 ? s[key][logIndex - 1] : false);
                    return s;
                })
            }else{
                //console.warn('Trying to update log item but not found!', get(state)[key], logIndex);
            }
        }
        

        perfMeasure('sync.sendUpdate.queue', () => sendUpdate(), {type}); // Only one person ever updates. No need for await because it has its own queue

        if(result == 'cancelled'){
            if(compound){
                state.update(s => {
                    console.log('resetting')
                    return savedState;
                })
                if(action.log && action.log(params)) closeWorkingLog();
            }else{
                state.update(s => {
                    console.log('resetting')
                    return savedState;
                })
                //if(action.log && action.log(params)) removeLastLog();
            }
        }else if(result == 'failed'){
            // end
            closeWorkingLog();
        }
       

    }catch(e){ 
        if(e == 'cancelled'){// Action was cancelled
            if(compound){
                console.log('cancelled')
                state.update(s => {
                    console.log('resetting')
                    return savedState;
                })
                if(action.log && action.log(params)) closeWorkingLog();
                result = 'cancelled';
            }else{
                throw 'cancelled';
            }
            
        }else if(e == 'continue_resolution'){
            throw e;
        }else if(e == 'uncompleted'){
            ui.update(ui => {
                delete ui.per;
                return ui;
            })
            throw e;
        }else if(e == 'completed'){
            ui.update(ui => {
                delete ui.per;
                return ui;
            })
            //throw 'completed'; 
            // Should just carry on?
        }else{
            await info(`Error encountered during action: ${e.message}`, ['OK']);
            console.log('Error type', e);
        }
    }
    if(compound && action.log && action.log(params)){
        closeWorkingLog();
    }else{
        console.log('updating state');
    }

    perfMeasure('action.logStats', () => logStats(p, type, params), {type});
    perfMeasure('ui.clearSelection', () => clearSelection(), {type});

    await updateAllTypeGains(); //perfMeasureAsync('transients.updateAllTypeGains', () => updateAllTypeGains(), {type});
    updateAllTransients();
    
    //perfMeasure('transients.updateAllTransients.request', () => updateAllTransients(), {type});

    endDoAction({type, result});
    return result;
}

export function updateAllTransients(){
    const end = perfStart('transients.updateAllTransients');
    updateTransientOngoing();
    //dbUpdateTransientOngoing(); // has to be immediate because of potential reliance on it
    if(!get(res).BvB){
        // None of these are needed in BvB I think
        dbUpdateMissions(); // Should debounce so it's not constantly firing
        dbUpdateHandSize();
        dbUpdatePlayerScores();
    }
   
    end();
}

export function updateTransientOngoing(){
    const end = perfStart('transients.updateOngoing');
    for(let i = 0; i < get(state).players.length; i++){
        let p = get(state).players[i];
        let ongoingCards = p.ongoing;
        for(let c of ongoingCards){ // [...ongoingCards, ...ongoingCards] // Doubling it so that trait additions contribute
            let ongoing = ongoingEffects(c, 'ongoing', true);
            for(let o of ongoing){
                handleOngoingChange(p, c, o, 'continuing');
            }
        }
    }
    end();
}

const dbUpdateTransientOngoing = debounce(updateTransientOngoing, 500);

export function updateHandSize(){
    const end = perfStart('transients.updateHandSize.request');
    for(let i = 0; i < get(state).players.length; i++){
        let p = get(state).players[i];
        handSize(p).then((hs) => {
            state.update(s => {
                s.players[i].currentHandSize = hs;
                return s;
            })
        })
    }
    end();
}

const dbUpdateHandSize = debounce(updateHandSize, 500);


export async function updatePlayerScores(){
    const end = perfStart('transients.updatePlayerScores');
    let scores = [];
    for(let p of get(state).players){
        scores.push(await scorePlayer(p));
    }
    state.update(s => {
        for(let p of get(state).players){
            p.score = scores[0];
            scores = scores.slice(1);
        }
        return s;
    })
    end();
}
const dbUpdatePlayerScores = debounce(updatePlayerScores, 500);

function makePatch(one, two){
    // Unified function for easy changes
    return jsonpatch.compare(one, two);
    //return Diff.diffJson(one, two);
    //return diff.diff(one, two);
    //return Diff.structuredPatch('state', 'state', JSON.stringify(one), JSON.stringify(two), '', '');
}


function doPatch(s, patch){
    jsonpatch.applyPatch(s, patch);
    return s;
    //return Diff.applyPatch(s, patch);
    //return diff.applyDiff(s, patch);
    //let newJSON = Diff.applyPatch(JSON.stringify(s) , patch);
    //return JSON.parse(newJSON);
}

export function getLogForTurn(state, turn = -1){
    // TODO let it select turn
    let log = Array.isArray(state.log) ? [...state.log] : [];
    if(Array.isArray(state.workingLog)) log = [...log, ...state.workingLog];
    //console.log('getting turn log')
    for(let i = log.length - 1; i >= 0; i--){
        if(log[i] && log[i].event == 'playerTurn'){
            return log.slice(i);
        }
    }
    return log;
}

// Generous: a single action phase never gets near this, so Undo behaves as before
// while the array stops growing for the length of the game.
const MAX_PREV_STATES = 50;

export function updateState(force = false, addUndo = true){
    const end = perfStart('state.updateState', {force, addUndo});
    if(get(res).BvB){
        end({force, addUndo, skipped: 'BvB'});
        return; // No point for BvB
    }
    let delta;
    let undo;

    // TODO remove once clear what size we can handle
    //console.log('State size: '+formatBytes(JSON.stringify(get(state)).length));
    //console.log('State size compressed: '+formatBytes(pako.deflate(JSON.stringify(get(state))).length));

    

    if(get(prefs).fullDeltas){
        delta = makePatch(get(res).savedState, get(state));
        undo = makePatch(get(state), get(res).savedState);
        if(!delta) return;
    }
    
    if(addUndo){
        perfMeasure('state.updateUndoSnapshots', () => res.update(r => {
            if(get(prefs).fullDeltas){
                r.deltas = [...r.deltas, delta];
                r.undos = [...r.undos, undo];
            }
            r.prevStates = [...r.prevStates, r.savedState];
            // Each entry is a full state clone — a late-game one is ~290kB — and
            // nothing trimmed this outside one bot-specific branch, so it grew for
            // the whole game. undoThreshold is an index into this array (see
            // turns.js, action/playing), so anything dropped off the front has to
            // move it down by the same amount or Undo silently stops working.
            if(r.prevStates.length > MAX_PREV_STATES){
                let dropped = r.prevStates.length - MAX_PREV_STATES;
                r.prevStates = r.prevStates.slice(dropped);
                if(typeof r.undoThreshold == 'number') r.undoThreshold = Math.max(0, r.undoThreshold - dropped);
            }
            r.savedState = perfMeasure('state.cloneSavedState', () => clone(get(state)));
            return r;
        }), {force, addUndo});
    }
    // currentplayer??
    if(force || isMe(get(state).activePlayer)){
      sendUpdate(force); // Only one person ever updates
    }
    end({force, addUndo});
}

async function stepForward(){
    let r = get(res);
    let next = r.deltas[r.nextDelta];
    let savedState = clone(get(state));
    state.update(s => {
        //console.log(s, next);
        s = doPatch(s, next);
        //console.log(s)
        return s;
    })
    await doActionPause();//await waitMillis(200);
    res.update(r => {
       let toUndo = makePatch(get(state), savedState);
        r.undos.push(toUndo);
        r.nextDelta++;
        return r;
    })
}

async function stepBack(){
    // This is the version presuming undos are not saved (i.e. they must be generated)
    let prev;
    res.update(r => {
        prev = r.undos.pop();
        r.nextDelta--;
        return r;
    })
    state.update(s => {
        s = doPatch(s, prev);
        return s;
    })
    await doActionPause();//await waitMillis(200);
}

export async function replayNext(){
    let r = get(res);
    if(r.deltas.length == 0 || r.nextDelta >= r.deltas.length - 1) return;
    while(get(res).nextDelta < r.deltas.length && !get(state).workingLog){ // To get to next one{
        await stepForward();
    }
    let startingLength = get(state).log.length;
    while(get(res).nextDelta < r.deltas.length - 1 && get(state).log.length == startingLength){
        //let wl = get(state).workingLog;
        await stepForward();
    }
    await tick();
    console.log(get(state));
}

export async function replayPrev(){
    let r = get(res);
    if(!r.undos || r.undos.length == 0) return;
    if(get(state).workingLog) state.update(s => {
        s.workingLog = false;
        return s;
    })
    while(r.undos.length > 0){ // Undo whole actions{
        await stepBack();
        let prev = r.undos[r.undos.length - 1];
        let prevState = clone(get(state));
        prevState = doPatch(prevState, prev);
        if(prevState.phase == get(state).phase && prevState.log.length < get(state).log.length) break;
        state.update(s => {
            s = prevState;
            return s;
        })
    }
    await tick();
}

export async function undo(){
    // Only allow if in one-player mode? But maybe later during turn too?
    let undoing;
    let prevState;
    let dbID = get(state).dbID;
    let gameID = get(state).gameID;
    //console.log(get(res));
    if(get(res).fullDeltas && (get(res).undos.length == 0 || get(res).deltas.length == 0) || get(res).prevStates.length == 0) return;
    do{
        res.update(r => {
            if(get(res).fullDeltas){
                r.deltas.pop();
            //console.log(last)
            //undoing = diff.reverse(last);
                r.undos.pop();
            }
            prevState = r.prevStates.pop();
            return r;
        })

        //console.log(undoing);
    
        state.update(s => {
            //s = doPatch(s, undoing);
            s = prevState;
            //jsonpatch.applyPatch(s, undoing);
            return s;
        })
        await doActionPause();//await waitMillis(200);
    }while(get(state).workingLog && get(state).workingLog.length > 0) // Undo whole actions

    state.update(s => {
        s = prevState; // Properly reset
        if(!s.dbID) s.dbID = dbID;
        if(!s.gameID) s.gameID = gameID;
        return s;
    })

    res.update(r => {
        r.savedState = clone(get(state));
        return r;
    })
    saveIfCan();
    if(get(state).gameShared) await rollbackMessages('current_games', get(state).dbID, get(state).gameID, get(state).offerCounter);
    updateState(false, false); // Is this the right thing?
}

export function logText(text, grey = false, us = true){
    let newEntry = {
        event: 'text',
        p: get(state).activePlayer,
        text
    };
    if(grey) newEntry.g = 1;
    log(newEntry, us);
}

export function log(l, us = true){
    let newEntry = {
        ...l
    };
    let index = 0;
    state.update(s => {
        if(Array.isArray(s.workingLog)){
            
            s.workingLog = appendLog(s.workingLog, newEntry);
            index = s.workingLog.length - 1;
        }else{
            
            s.log = appendLog(s.log, newEntry);
            index = s.log.length - 1;
            saveIfCan();
        }
        return s;
    })
    //if(us) updateState();
    return index;
}



function saveIfCan(){
    if(get(res).BvB) return;
    if(get(ui).canSave && !get(ui).catchingUp){
        resetContinuationBaseline('save');
        saveGameSoon();
        //updateGame(get(state), [], get(ui), 'all');
        //dbUpdateGame(get(state), [], get(ui), 'all');
    }else{
        ui.update(ui => {
            ui.saved = false;
            return ui;
        });
        //dbUpdateGame(get(state), get(state).choices.thisTurn, get(ui), ['changelist']);
    }
}

export function removeLastLog(l){
    state.update(s => {
        if(Array.isArray(s.workingLog)){
            s.workingLog.pop();
        }else{
            s.log.pop();
        }
        return s;
    })
}

function appendLog(log, entry, stringifyEnd = false){
    // Check for duplicates that could be handled

    let last = log[log.length - 1];
    //if(last && last.elements && last.elements.length > 0) last = last.elements[last.elements.length - 1];
    if(last){
        if(last.type == 'gain_tokens' && entry.type == 'gain_tokens' && entry.p == last.p && last.params.token == entry.params.token && !entry.elements){
            last.params.amount += entry.params.amount;
            if(last.params.amount == 0){
                // remove entry!
                return log.slice(0, log.length - 1);
            }
            return log;
        }
        // Do drawing/discarding next
        if(last.type == 'draw' && entry.type == 'draw' && entry.p == last.p && entry.params && entry.params.drawn && !entry.elements){
            last.params.obj.num += entry.params.obj.num;
            console.log('adding draw', last, entry, get(state).log, get(state).workingLog);
            last.params.drawn = [...last.params.drawn, ...entry.params.drawn];
            return log;
        }
        let preLast;
        if(log.length >= 2) preLast = log[log.length - 2];
        // Now we stringify inside takeAction instead
        //if(last.event == 'action') log[log.length - 1] = stringifyLogItem(last, preLast);

    }
    
    //if(stringifyEnd) entry = stringifyLogItem(entry, last);
    
    console.log('appending log', log, entry)
    return [...log, entry];
}

function stringifyLogItem(item, preLast){
    if(item.text) return item;
    if(typeof item == 'string') return item;
    let newItem = /*getActionLog(item, !(preLast && preLast.p == item.p));*/ {
        event: 'text',
        p: item.p,
        text: setHiddenCards(getActionLog(item, !(preLast && preLast.p == item.p)), item.params)
    }
    if(item.g) newItem.g = item.g;
    if(!newItem.text){
        console.log('Unsuccessful log consolidation:', item);
        return item;
    }
    //console.log('attempt to make hidden cards hidden', setHiddenCards(getActionLog(item, !(preLast && preLast.p == item.p)), item.params));
    return newItem;
}

function setHiddenCards(s, params){
    if(!params){
        //console.warn('No params for hidden cards setting: returning string as-is');
        return s;
    }
    if(!s) return '';
    let breakdown = s.split('$|');
    let processed = [];
    for(let b of breakdown){
        if(!b.includes('|$')){
            processed.push(b);
        }else{
            let [co, cRest] = b.split(',');
            if(!cRest){
                processed.push(`${b}`);
                continue;
            }
            let [id, rest] = cRest.split('|$');
            if(id == -1){
                processed.push(`v${b}`);
            }else{
                if(params.hidden && params.hidden[id]){
                    processed.push(`h${b}`);
                }else{
                    // Presume visible (for now?)
                    processed.push(`v${b}`)
                }
            }
        }
    }
    return processed.join('$|');
}

//let savedState = '';

export function openWorkingLog(){
    if(get(state).workingLog) return;
    //savedState = JSON.stringify(get(state));
    state.update(s => {
        s.workingLog = [];
        return s;
    })
    //updateState();
}

export function closeWorkingLog(){
    let wl = get(state).workingLog;
    if(!Array.isArray(wl)) return;
    //updateState(); // So that other player gets a moment to read it

    state.update(s => {
        let first = wl[0];
        if(first){
            if(wl.length > 1){
                first.elements = wl.slice(1);
            }
            first.newInfo = newInfo;
            let string = '';
            let convert = true;
            if(first.text){
                string = first.text + '.';
                if(first.elements){
                    let last = false;
                    for(let e of first.elements){
                        if(e.text){
                            string += ` $${e.g ? '!' : ''}${e.text}.`;  
                        }else if(e.type && stringifyLogItem(e, last).text){
                            let s = stringifyLogItem(e, last);
                            string += ` $${e.g ? '!' : ''}${s.text}.`;
                        }else{
                            console.log(`Can't convert this WL item to text`, first.elements)
                            convert = false;
                        }
                        last = e;
                    }
                }
                if(convert) first = string;
            }
            s.log = appendLog(s.log, first, true);
        }
        s.workingLog = false;
        saveIfCan();
        return s;
    })
    updateState();
}

async function checkZones(_state, _res, deck, i){
    let source = {
        market_zone: 'market',
        neutral_zone: 'locations'
    }
    if(Object.values(_res.marketTypes).includes(deck) && get(state).commons[deck].length > 0){
        // Check whether there's a new top card here
        let c = get(state).commons[deck][0];
        if(c){
            c.entered = {
                turn: get(state).turn,
                location: 'market'
            }
        }
        // trigger reaction
        await checkForReactions(activePlayer(), 'market_reveal', {obj: c.uniqueID}, 'before');
        await checkForReactions(activePlayer(), 'market_reveal', {obj: c.uniqueID}, 'after');
    }
    if(deck == 'market_zone' && get(prefs).separateMarkets) return; // Don't bother unless using blended market
    if(deck == 'market_zone' || deck == 'neutral_zone'){
        if(get(state).commons[source[deck]].length > 0){
            let c = get(state).commons[source[deck]][0];
            console.log('adding to market', i);
            state.update(s => {
                s.commons[deck].splice(i, 1); // Take away undefined bit
                return s;
            })
            if(c){
                c.entered = {
                    turn: get(state).turn,
                    location: deck
                }
            }
            await moveTo(get(state).commons[source[deck]][0], 'commons.'+deck, i);
            if(deck == 'neutral_zone' && get(state).practice){
                c.away_teams = {};
                c.away_teams[get(state).players[1].captain] = 1;
            }
        }else{
            //_state.commons[deck] = [..._state.commons[deck].slice(0, i), undefined, ..._state.commons[deck].slice(i)];
        }
    }
}

export async function removeBeamed(c, deck){
    if(!c.beamed) return;
    for(let card of c.beamed){
        console.log(card);
        if(card.sourcePlayer === undefined) throw 'All beamed cards should have a source!';
        if(deck == 'hand'){
            await doAction(get(state).players[card.sourcePlayer], 'hand', {card: card.uniqueID}); // Recalling cards recalls their beamed cards
        }else if(deck == 'log'){
            await doAction(get(state).players[card.sourcePlayer], 'log', {card: card.uniqueID}); // Logging cards logs their beamed cards
        }else if(deck == 'assimilated'){
            await doAction(get(state).players[card.sourcePlayer], 'assimilate', {card: card.uniqueID}); // Assimilating cards assimilates their beamed cards
        }else{
            await doAction(get(state).players[card.sourcePlayer], 'dismiss', {card: card.uniqueID});
        }
    }
    delete c.beamed;
}

export async function removeOrbiting(c, deck){
    if(!c.orbiting) return;
    for(let o of c.orbiting){
        if(o.sourcePlayer === undefined) throw 'All orbiting ships should have a source!';
        let card = getCard(o.card);
        if(getLocation(card).deck == 'fleet'){
            await doAction(get(state).players[o.sourcePlayer], 'dismiss', {card: card.uniqueID});
        }
        state.update(s => {
            if(!s.cache) s.cache = {};
            if(!s.cache.shipsDismissed) s.cache.shipsDismissed = 0;
            s.cache.shipsDismissed++;
           
            return s;
        })
    }
    delete c.orbiting;
}
async function returnVisiting(c){
    if(c.visiting){
        for(let v of c.visiting){
            // return if you can
            let r = getCard(v);
            // return token to card
            delete r.whereAmI; 
            if(!ongoingEffects(r).includes('no_visiting_dismissal')){
                try{
                    await doAction(activePlayer(), 'dismiss', {obj: v}); // Dismiss visiting card
                }catch(e){
                    if(!['uncompleted', 'completed'].includes(e)) throw e; // only dismiss if able
                }
                
            }
        }
        delete c.visiting; // All done!
    }
}

async function removeSpecialTokens(c){
    // Only defp at the moment: dismiss it
    if(c.defp){
        // c.defp = the ID of the defp card if it is sent
        let defp = getCard(c.defp);
        if(defp){
            delete defp.whereIsDefP; // So as not to trigger the below
            await doAction(activePlayer(), 'dismiss', {obj: c.defp});
        }
        delete c.defp;
        //defp.defp = defp.uniqueID;
        //defp.whereIsDefP = defp.uniqueID;
    }
    if(c.whereIsDefP){
        // so it's the owner card being dismissed
        let where = getCard(c.whereIsDefP);
        if(where){
            delete where.defp; // So as not to trigger the above
            await doAction(activePlayer(), 'dismiss', {obj: c.whereIsDefP});
        }
        delete c.whereIsDefP;

    }
}

function returnShips(c){
    if(!c.orbitingCard) return;
    //console.log('checking')
    for(let o of Object.keys(c.orbitingCard)){
        let card = getCard(c.orbitingCard[o]);
        card.orbiting = card.orbiting.filter(s => !(s.ship == o && s.card == c.uniqueID)); // another copy of this ship card may share the name
        if(card.orbiting.length == 0) delete card.orbiting;
        state.update(s => {
             // Add location to list of previous places in case of referring back to 'the same location' or similar
             if(!s.cache) s.cache = {};
             if(!s.cache.allPrev) s.cache.allPrev = [];
             s.cache.allPrev = [card.uniqueID, ...s.cache.allPrev];
             return s;
        })
    }
    delete c.orbitingCard;
}

export async function moveTo(c, key, index = 0){
    // TODO I suspect any duplication/disappearance problems are down to this routine
    // To make more robust:
    // - make it update state properly rather than in via mediation
    // - put the removal and reinstatement bits right next to each other, maybe via calls to another routine
    // - add try/catch handling if need be with graceful fallback
    if(!c) return false;
    if(c.id == 'DUMMY') return true; // skips
    addCardToIndex(currentCardIndex(), c);
    let [area, deck, player] = key.split('.')
    let place = get(state).cardLog[c.uniqueID];
    if(!place){
        throw `Card ${c.uniqueID} (${c.name}) not in system!`
    }
    let origDeck = getDeck(get(state), place.area, place.deck, place.player);
    let origIndex = origDeck.findIndex(card => card == c);
    let atEnd = false;
    let closingActions = [];
    if(index == -1) atEnd = true;

    if(c.suits && c.suits.includes('mission') && area == 'players' && ['hand', 'deck', 'discard'].includes(deck)){
        deck = 'missions'; // Missions never enter hand/deck
    }

    if(deck == 'hand' && get(state).players[player].bot){
        /*throw {
            message: "Should not put stuff in bot hand!"
        }*/
        deck = 'discard'; // Just move it
    }

    if(place.deck == 'reserve' && get(state).players[player] && get(state).players[player].bot && get(state).players[player].captain == 'Khan' && get(state).players[player].currentChart == 'exile'){
        // Gains dilithium for this
        closingActions.push(async () => {
            logText('Bot gaining [[dilithium]] because of Supplement draw/discard');
            await doAction(get(state).players[player], 'gain_tokens', { token: 'dilithium', amount: 1});
        });
        
    }

    /*if(deck == 'discard' && place.deck == 'hand' && player == place.player && ongoingPlayer(_state.players[player]).includes('discard_beam')){
        let p = _state.players[player];
        for(let cd of cardsInPlay(p)){
            let cost = ongoingEffects(cd, 'discard_beam_cost').flat(2);
            if(cost && cost.length > 0){
                cost = cost[0]; // Should be fine, there won't be more than 1 per card
            }else{
                cost = false;
            }
            if(cost && await canPay(p, cost, 'discard_beam')){7
                let info = await getCostInfo(p, cost, 'discard_beam');
                let choice = await choose(`You may pay ${renderCost(info)} to beam ${cc(c.uniqueID)} to ${cc(cd.uniqueID)} instead. Do you want to do this?`, ['Yes', 'No']);
                if(choice == 'Yes'){
                    try{
                        await pay(p, cost, 'discard_beam', cd);
                        area = 'beamed';
                        deck = cd.uniqueID;
                    }catch(e){
                        logText(`Not able to ${cost}, so not beaming card`);
                    }
                }
            }
        }
    }*/

    if(place.area == 'player_dashboards') return false; // Can't move dashboard missions
    
    
    if(area == place.area && deck == place.deck && parseInt(player) == parseInt(place.player) && (index == origIndex || index == -1 && origIndex == origDeck.length - 1)){
        return; // Don't bother moving if it's still in the same place
    }

    let sourcePlayer = null;

    let inPlayBefore = inPlay(c);// tableEffectsActive(c);
    // Note that the above is heuristic: specials that play with ongoing in a live way
    // are generally only for cards either in play or staging, for obvious reasons
    // if there were any chance it could go beyond this, enable the below,
    // which is a bit slower
    //let ongoingBefore = ongoingEffects(c).length;

    console.log('moving', c, key, place, index);

    
    

    if(ongoingEffects(c, 'ongoing').includes('mimic_location') && deck == 'fleet') deck = 'locations'
    //if(ongoingEffects(c, 'ongoing').includes('mimic_ship') && deck == 'play') deck = 'fleet'

    if(area != place.area || deck != place.deck || parseInt(player) != parseInt(place.player) ){
        // Remove any beamed cards and looks tied to this
        // Don't do it if you're just shifting left or right
        if(!['fleet','locations','play'].includes(deck)) await removeBeamed(c, deck);
        if(c.whereAmI){
            // Unteleport it
            let visitingCard = getCard(c.whereAmI);
            if(visitingCard.visiting) visitingCard.visiting = visitingCard.visiting.filter(v => v != c.uniqueID);
            delete c.whereAmI;
        }
        await removeOrbiting(c, deck); // TODO here?
        await removeAllAway(c);
        await returnVisiting(c);
        await removeSpecialTokens(c);
        //if(key.includes('beamed')) returnShips(c);
        returnShips(c); 
        removeLooks(c);
        c.activated = false; //
        await tick(); // Let those things happen before moving
    }

    if(player && parseInt(player) != 0 && get(state).practice && c.suits.includes('incident')){
        // Don't actually move it, but give Glory instead
        //console.log('no incident, glory instead');
        logText('Other player should take incident, so you gain [[glory]] instead')
        await doAction(get(state).players[0], 'gain_tokens', {token: 'glory', amount: 1, fromSupply: true})
    }

    // First remove from existing place
    // Jan 2026: re-load this after stripping any beamed cards
    // This should prevent Levitation Boots from duplicating
    // if it self-dismisses mid-move
    place = get(state).cardLog[c.uniqueID];
    if(!place){
        throw `Card ${c.uniqueID} (${c.name}) not in system!`
    }
    origDeck = getDeck(get(state), place.area, place.deck, place.player);
    origIndex = origDeck.findIndex(card => card == c);
    let i = 0;
    if(place.area == 'commons'){
        
        i = get(state).commons[place.deck].findIndex(cd => cd && cd.uniqueID == c.uniqueID);
        if(place.deck == 'market_zone' || place.deck == 'neutral_zone'){
            state.update(s =>{
                s.commons[place.deck] = [...s.commons[place.deck].slice(0, i), null, ...s.commons[place.deck].slice(i+1)];
                return s;
            })
            
        }else{
            state.update(s =>{
                s.commons[place.deck] = [...s.commons[place.deck].slice(0, i), ...s.commons[place.deck].slice(i+1)];
                return s;
            })
            
        }
        
    }else if(place.area == 'players'){
        sourcePlayer = place.player;

        if(sourcePlayer != player /*&& typeof player !== 'undefined'*/){
            if(!get(state).cache) get(state).cache = {};
            if(!get(state).cache.cardOwner) get(state).cache.cardOwner = {};
            get(state).cache.cardOwner[c.uniqueID] = parseInt(sourcePlayer); // So that it remembers the original owner until the end of the action
        }
        
        let i = get(state).players[place.player].decks[place.deck].findIndex(cd => cd && cd.uniqueID == c.uniqueID);
        state.update(s => {
            s.players[place.player].decks[place.deck] = [...s.players[place.player].decks[place.deck].slice(0, i), ...s.players[place.player].decks[place.deck].slice(i+1)];
            return s;
        })
        
        if(place.deck == 'hand'){
            let p = get(state).players[place.player]
            if(p.decks.hand.length == 0){
                closingActions.push(async () => {
                    await doActionPause();
                    await checkForReactions(p, 'hand_empty', {}, 'after');
                });
            }
        }else if(place.deck == 'reserve'){
            let p = get(state).players[place.player]
            if(p.decks.reserve.length == 0){
                if(get(state).campaign && get(state).campaignInfo.onTuesday && p.setAsideAT){
                    closingActions.push(async () => {
                        await doActionPause();
                        logText(`They Will Arrive on Tuesday: adding ${p.setAsideAT} [[away team]] back to your [[captain]] card`);
                        let pool = atPool(p);
                        if(!p.decks.captain[0][pool]) p.decks.captain[0][pool] = {};
                        if(!p.decks.captain[0][pool][p.captain]) p.decks.captain[0][pool][p.captain] = 0;
                        p.decks.captain[0][pool][p.captain] += p.setAsideAT;
                        p.setAsideAT = 0;
                    })
                }
            }
        }
    }else if(place.area == 'beamed'){
        let card = cardByID(place.deck); 
        sourcePlayer = c.sourcePlayer;

        console.log(card);
        if(card.beamed){
            card.beamed = card.beamed.filter(cd => cd.uniqueID != c.uniqueID);
            if(card.beamed.length == 0) delete card.beamed;
        }else{
            console.log('Card has no beamed cards – should not happen!', card, place.deck)
        }
        if(getCardEffect(card, 'passive').flat(3).some(e => e.effect.flat(3).some(f => f.condition == 'none_beamed_here'))){
            let effect = getCardEffect(card, 'passive').flat(3).find(e => e.effect.flat(3).some(f => f.condition == 'none_beamed_here'));
            if(effect){
                let specific = effect.effect.flat(3).find(f => f.condition == 'none_beamed_here');
                closingActions.push(async () => { await doActionPause(); await resolveEffects(card, specific, effect.attack, false); });
            }
        }
        if(ongoingEffects(card).includes('no_beamed_dismiss')){
            // Dismiss card because no cards left beamed to it
            logText(`No cards left beamed to ${cc(card)}: dismissing`);
            await doAction(get(state).players[sourcePlayer], 'dismiss', {obj: card.uniqueID});
        }
    }

    

    // Then add to new deck
    if(area == 'commons'){
        if(index == -1) index = get(state).commons[deck].length;
        state.update(s => {
            s.commons[deck] = [...s.commons[deck].slice(0, index), c, ...s.commons[deck].slice(index)];
            //console.log(_state.commons[deck])
            s.cardLog[c.uniqueID] = {
                area: 'commons',
                deck
            }
            return s;
        })
        
        await removeTokens(c);
        delete c.sourcePlayer;
    }else if(area == 'players'){
        if(index == -1) index = get(state).players[player].decks[deck].length;
        state.update(s => {
            s.players[player].decks[deck] = [...s.players[player].decks[deck].slice(0, index), c, ...s.players[player].decks[deck].slice(index)];
            s.cardLog[c.uniqueID] = {
                area: 'players',
                player,
                deck
            };
            return s;
        })
        
        let giveTo = false;
        if(place.area == 'commons') giveTo = get(state).players[player];
        await removeTokens(c, giveTo); // So you don't gain by default
        if(!c.entered) c.entered = {};
        if(!c.entered.hasOwnProperty('turn')){
            c.entered = {
                turn: get(state).turn,
                location: get(state).players[player].captain
            }
        }
        if(ongoingEffects(c).includes('on_log') && deck == 'log'){
            let action = ongoingEffects(c, 'on_log');
            closingActions.push(async () => { 
                logText(`${cc(c.uniqueID)} was logged, so performing log effect`);
                await doActionPause(); await resolveEffects(c, action, action.some(a => a.attack), false); 
            });
        }
        delete c.sourcePlayer;
    }else if(area == 'beamed'){ // Format 'beamed.345' where 345 is the unique ID of the card
       let toCard = getCard(deck);
       if(!sourcePlayer) sourcePlayer = get(state).activePlayer; // As a default
       c.sourcePlayer = sourcePlayer;
       if(!toCard) return;
       if(!toCard.beamed){
            toCard.beamed = [];
       }
       toCard.beamed = [...toCard.beamed.slice(0, index), c, ...toCard.beamed.slice(index)];
       state.update(s => {
            s.cardLog[c.uniqueID] = {
                area: 'beamed',
                deck
            };
        return s;
       })
       
       let giveTo = false;
        if(place.area == 'commons') giveTo = get(state).players[player];
        await removeTokens(c, giveTo); // So you don't gain by default
       //await removeTokens(c, _state.players[player]);
    }

    await checkZones(get(state), get(res), place.deck, i);

    // strictly, 'when' should check before the move, but that wouldn't work if it wasn't in play before
    if(place.deck != deck){
        let p = get(state).players[player];
        if(p) await checkForReactions(p, 'enters', {place: deck, obj: c.uniqueID}, 'before');
    }

    if(place.deck != deck){
        let p = get(state).players[player]
        if(p) await checkForReactions(p, 'enters', {place: deck, obj: c.uniqueID}, 'after');
    }

    let inPlayAfter = inPlay(c); //tableEffectsActive(c);
    // Note that the above is heuristic: specials that play with ongoing in a live way
    // are generally only for cards either in play or staging, for obvious reasons
    // if there were any chance it could go beyond this, enable the below,
    // which is a bit slower
    //let ongoingAfter = ongoingEffects(c).length;

    let ongoingChange = null;

    if(inPlayBefore && !inPlayAfter) ongoingChange = 'leaving';
    if(!inPlayBefore && inPlayAfter) ongoingChange = 'entering';
    /*if(!ongoingChange){
        if(ongoingBefore && !ongoingAfter) ongoingChange = 'leaving';
        if(!ongoingBefore && ongoingAfter) ongoingChange = 'entering';
    }*/

    /*if(ongoingEffects(c, 'ongoingTrigger', true).length > 0){
        // Custom location trigger
        let t = ongoingEffects(c, 'ongoingTrigger', true)[0].toLowerCase();
        if(place.deck == t && deck != t) ongoingChange = 'leaving';
        if(place.deck != t && deck == t) ongoingChange = 'entering';
    }*/
    if(ongoingChange){
        let ongoing = ongoingEffects(c, 'ongoing', true);
        let p;
        if(ongoingChange == 'entering'){
            p = get(state).players[player];
        }else{
            p = get(state).players[sourcePlayer];
        }
        for(let o of ongoing){
            await handleOngoingChange(p, c, o, ongoingChange)
        }
        if(ongoingChange == 'leaving' && c.savedTraits){
            c.traits = c.savedTraits;
            delete c.savedTraits; // Remove lingering traits
        }
    }

    if(get(state).commons.incidents.length == 0){
        // A burn!! End the game immediately
        let p = get(state).players[get(state).activePlayer];
        /*if(isMe(p) && !p.bot){
            let choice = await choose(`This action will cause the game to end via Burn. Do you really want to do this?`, ['Yes! 🔥', 'No']);
            if(choice == 'No' || choice == 'cancelled') throw 'cancelled';
        }*/
        endGame('Burn');
    }/*else if(get(state).commons.market && get(state).commons.market.length == 0){
        endGame('Market deck ran out');
    }else if(get(state).commons.allies && get(state).commons.allies.length == 0){
        endGame('Allies deck ran out');
    }else if(get(state).commons.people && get(state).commons.people.length == 0){
        endGame('People deck ran out');
    }else if(get(state).commons.cargo && get(state).commons.cargo.length == 0){
        endGame('Cargo deck ran out');
    }else if(get(state).commons.ships && get(state).commons.ships.length == 0){
        endGame('Ships deck ran out');
    }else if(get(state).commons.locations.length == 0 && get(prefs).endWhenLocationsRunOut){
        endGame('Location deck ran out');
    }else if(get(state).commons.missions.length == 0){
        endGame('Mission deck ran out');
    }*/

    if(area == 'players' && deck == 'hand'){
        if(get(ui).handElement[player]){
            if(index == 0){
                //console.log('scrolling left')
                get(ui).handElement[player].scrollTo({left: 0, behavior: 'smooth'});
            }else if(atEnd){
                //console.log('scrolling right to width')
                tick().then(() => {
                    get(ui).handElement[player].scrollTo({left: get(ui).handElement[player].scrollWidth, behavior: 'smooth'});
                });
            }
        }
    }

    if(place.area == 'players' && area == 'players' && place.deck == 'reserve' && deck == 'deck' && get(state).players[player].bot && get(state).players[player].captain == 'Culluh' && origIndex == 0 && index == 0){
        /* Whenever the Bot puts the top card of the Supplement deck on top of it's Deck, reveal it. If 5 [[away team]] or fewer and the revealed card has [[shady]] / [[attack]] / [[kazon]], add an [[away team]] (from supply) to the Bot Captain. */
        logText(`Culluh special rule: Whenever the Bot puts the top card of the Supplement deck on top of it's Deck, reveal it.`)
        let p = get(state).players[player];
        await doAction(p, 'reveal', {obj: [c.uniqueID]});
        if(availableAT(p) < 6 && matches(c, ['shady', 'attack', 'kazon'])){
            logText(`5 [[away team]] or fewer and the revealed card has [[shady]] / [[attack]] / [[kazon]], so adding [[away team]] to Bot Captain.`);
            await doAction(p, 'extra_away', {num: 1})
        }
    }

   //await updateAllTypeGains();

    for(let a of closingActions){
        await a();
    }

    ui.update(u => {
        u.selection = false;
        return u;
    })
    return true;
}

export function getDeckForCard(c){
    let info = get(state).cardLog[c.uniqueID];
    return getDeck(get(state), info.area, info.deck, info.player);
}

export function getDeck(state, area, deck, player){
    //console.log(state, area, deck)
    if(area == 'commons'){
        return state.commons[deck];
    }else if(area == 'players'){
        //console.log(player)
        return state.players[player].decks[deck];
    }else if(area == 'beamed'){
        return getCard(deck).beamed || [];
    }
    return [];
};

export function removeLooks(c){
    let looking = get(ui).looking;
    let toRemove = [];
    for(let l of looking){
        let deck = getDeck(get(state), l.area, l.deck, l.player);
        if(deck.length == 0) toRemove.push(l);
        console.log('look info', c, l, deck)
        if(!l.cards) continue;
        if(l.canReorder) continue;
        
        let index = l.cards.find(i => deck[i] && deck[i] == c);
        if(index != undefined){
            console.log('shortening look', l, index)
            l.cards = l.cards.filter(c => c != index);
        }
        console.log(l.cards);
        if(l.cards.length == 0){
            console.log('no cards!')
            toRemove.push(l);
        }
    }   
    for(let r of toRemove){
        closeLook(r);
    }
    /*looking = looking.filter(l => !toRemove.includes(l));
    ui.update(ui => {
        ui.looking = looking;
        return ui;
    })*/
}

function listTokens(c){
    let list = [];
    for(let t of allTokenTypes()){
        let count = c[t] || 0;
        while(count > 0){
            list = [...list, t];
            count--;
        }
    }
    return list;
}

function removeTokenFromCard(c, t){
    c[t]--;
    if(!c[t]) delete c[t];
}

export async function removeTokens(c, giveTo = false, justRes = false, num = 'all'){
    if(c.activated && !justRes) delete c.activated;
    let totalTokens = allTokenTypes().reduce((a,t) => a + (c[t] || 0), 0);
    let cannotTakeNum = false;
    if(num != 'all'){
        // Taking just a subset, so arrange this
        num = await resolveNum(num, 'gaining tokens');
        
        if(totalTokens < num) cannotTakeNum = true; // So it can't pay cost
        
        if(totalTokens > num){
            // There are more tokens than needed, so pick the ones you want in a loop
            let list = listTokens(c);
            let types = Array.from(new Set(list));
            let toGain = {};
            while(types.length > 1 && num > 0){
                // i.e. once there is only one type left, just roll on
                let possTypes = {};
                for(let t of types){
                    possTypes[`[[${t}]] (${c[t]} left)`] = t;
                }
                let soFar = ``;
                if(Object.keys(toGain).length > 0){
                    let items = [];
                    for(let k of Object.keys(toGain)){
                        items.push(`${toGain[k]} [[${k}]]`);
                    }
                    soFar = `${items.join(' ')} so far, `;
                }
                let choice = await choose(`Select token to ${giveTo ? 'gain' : 'remove'} from card (${soFar}${num} remaining):`, Object.keys(possTypes));
                if(!choice || choice == 'cancelled') throw 'cancelled';
                let t = possTypes[choice];
                num--;
                //removeTokenFromCard(c, t);
                if(!toGain[t]) toGain[t] = 0;
                toGain[t]++;
                //list = listTokens(c);
                let index = list.indexOf(t);
                list = [...list.slice(0, index), ...list.slice(index + 1)];
                types = Array.from(new Set(list));
            }
            let t = types[0];
            if(num > 0 && types.length == 0){
                console.log(`Error: no tokens left on card and ${num} still to remove`);
                throw 'uncompleted';
            }
            while(num > 0){
                //removeTokenFromCard(c, t);
                if(!toGain[t]) toGain[t] = 0;
                toGain[t]++;
                num--;
            }
            // Gain all removed tokens
            for(let t of Object.keys(toGain)){
                await doAction(giveTo, 'gain_tokens', {token: t, amount: toGain[t], fromCard: c.uniqueID});
            }
            return; // So that it doesn't roll over to below, which should only happen if you have just the right number of tokens
        }
    }

    for(let r of allTokenTypes()){//cardResourceTypes()){//get(res).cardResourceTypes){
        if(c[r]){
            if(giveTo){
                console.log('giving tokens', c)
                await doAction(giveTo, 'gain_tokens', {token: r, amount: c[r], fromCard: c.uniqueID});
            }
        }
        delete c[r]; // Not just setting to 0 because wanting to save space?
    }
    if(cannotTakeNum) throw 'uncompleted'; // Just for cost thing
   // delete c.activated; // Unexhaust too
}

export function getPlayerIndex(p){
    return get(state).players.findIndex(pl => pl.captain == p.captain);
}

function ongoingVariable(p, key, behaviour = 'sum', override = false){
    let relevant = ongoingPlayer(p, 'ongoing', override).filter(e => e.startsWith(key));
    let ret = 0;
    let found = false;
    if(relevant.length == 0) return false;
    for (let r of relevant){
        let i = parseInt(r.slice(key.length));
        if(isNaN(i)) continue;
        if(behaviour == 'sum'){
            ret += i;
        }else if(behaviour == 'max'){
            if(i > ret) ret = i;
        }else if(behaviour == 'min'){
            if(i < ret || !found) ret = i;
        }
        found = true;
    }
    return ret;
}

export async function dynamicHandSize(p, c, e){
    let adding = 0;
    if(!Array.isArray(e)) e = [e]; // grammar gives one object; handSize() gives a list of them
    for(let d of e){
        if(d.per){
            let amount = await resolveCount(p, c, d.per);
            if(amount > 0) amount = Math.floor(amount);
            /*let num = d.num;
            if(!typeof num != 'number'){
                if(num.min) 
            }*/
            adding += d.num * amount;
        }else if(d.condition){
            let shouldAdd = await resolveCondition(p, c, d.condition, false, false);
            if(d.instead){
                if(shouldAdd){
                    adding += d.conditional || 0;
                }else{
                    adding += d.base || 0;
                }
            }else if(d.another){
                adding += d.base || 0;
                if(shouldAdd){
                    adding += d.conditional || 0;
                }
            }else{
                console.warn('Dynamic hand without any additional condition info...!')
            }
        }
    }
    return adding;
}

export async function handSize(p, override = false){
    let adds = ongoingPlayer(p, 'ongoing', override).filter(e => e.startsWith('hand_increase_'));
    //console.log(adds);
    let adding = 0;
    for(let a of adds){
        //console.log(a.slice("hand_increase_".length))
        let i = parseInt(a.slice("hand_increase_".length ));
        if(!isNaN(i)) adding += i;
    }
    if(p.tempHandSizeIncrease) adding += p.tempHandSizeIncrease;
    for(let c of cardsInPlay(p, false, true)){
        if(ongoingEffects(c, 'ongoing', override).includes('hand_dynamic')){
            let e = ongoingEffects(c, 'hand_dynamic', override);
            adding += await dynamicHandSize(p, c, e);
            // Deleted duplication here I think, reinstate if borked!
        }
    }
    for(let c of cardsInPlay(p, false, true)){
        if(ongoingEffects(c, 'ongoing', override).includes('hand_conditional')){
            let e  = ongoingEffects(c, 'hand_conditional', override);
            for(let d of e){
                let should_do = await resolveCondition(p, c, d.condition, false);
                if(should_do) adding += d.num;
            }
        }
    }
    return Math.max(p.handSize + adding, 0);
}

export function cleanUp(){
    for(let p of get(state).players){
        for(let d of Object.keys(p.decks)){
            for(let c of p.decks[d]){
                let info = get(state).cardLog[c.uniqueID];
                if(info.deck != d || info.area != 'players'){
                    p.decks[d] = p.decks[d].filter(card => card.uniqueID != c.uniqueID);
                }else{
                    if(p.decks[d].filter(card => card.uniqueID == c.uniqueID).length == 0){
                        p.decks[d].push(c);
                    }else if(p.decks[d].filter(card => card.uniqueID == c.uniqueID).length > 1){
                        let i = p.decks[d].findIndex(card => card.uniqueID == c.uniqueID);
                        p.decks[d] = p.decks[d].filter((card, ind) => i == ind || card.uniqueID != c.uniqueID); // only keep first one
                    }
                }
                if(c.beamed){
                    let newBeamed = [];
                    for(let cd of c.beamed){
                        if(!newBeamed.some(b => b.uniqueID == cd.uniqueID)) newBeamed.push(cd);
                    }
                    c.beamed = newBeamed;
                }
            }
        }
    }
    for(let d of Object.keys(get(state).commons)){
        for(let c of get(state).commons[d]){
            let info = get(state).cardLog[c.uniqueID];
            if(info.deck != d || info.area != 'commons'){
                get(state).commons[d] = get(state).commons[d].filter(card => card.uniqueID != c.uniqueID);
            }else{
                if(get(state).commons[d].filter(card => card.uniqueID == c.uniqueID).length == 0){
                    get(state).commons[d].push(c);
                }else if(get(state).commons[d].filter(card => card.uniqueID == c.uniqueID).length > 1){
                    let i = get(state).commons[d].findIndex(card => card.uniqueID == c.uniqueID);
                    get(state).commons[d] = get(state).commons[d].filter((card, ind) => i == ind || card.uniqueID != c.uniqueID); // only keep first one
                }
            }
        }
    }

    for(let c of allCards()){
        if(c.traits && Array.isArray(c.traits)){
            c.traits = Array.from(new Set(c.traits)); // Unduplicate
        }
    }
    closeAllLooks();
    state.update(s => {
        return s; // To update it
    })
}

export function isEligibleForReaction(c, type, ignoreActivated = false){
    if(type == 'special') return true;
    if(type == 'reaction') return tableEffectsActive(c) && (!c.activated || ignoreActivated && isInReactionStack(ignoreActivated)); // ignoreActivated == code for effect
    if(type == 'passive' || type == 'resupply') return tableEffectsActive(c);
    if(type == 'support') return getLocation(c).deck == 'hand';
    if(type == 'cleanup') return tableEffectsActive(c) || getLocation(c).deck == 'play';
    return false;

}

function pushCurrentReaction(code){
    state.update(s => {
        if(!s.currentReaction) s.currentReaction = [];
        s.currentReaction = [code, ...s.currentReaction];
        return s;
    })
}

function popCurrentReaction(){
    state.update(s => {
        if(s.currentReaction) s.currentReaction = s.currentReaction.slice(1);
        if(s.currentReaction.length == 0) delete s.currentReaction;
        return s;
    })
}

function isInReactionStack(code){
    if(!get(state).currentReaction) return false;
    return get(state).currentReaction.includes(code);
}

export function resetCache(){
    console.log('resetting cache');
    state.update(s => {
        s.cache = {
            allPrev: [],
        };
        return s;
    })
}

export function getP(p){
    return get(state).players.find(pl => pl.captain == p.captain);
}

export async function checkForReactions(p, type, params, timing = 'before', defer = false){
    const endCheckReactions = perfStart('reaction.checkForReactions', {type, timing});
    //if(get(state).reacting) return; // Can't react in a reaction
    //console.log('checking reactions', type, params, timing)
    
    // !! NB below we used to say you couldn't react in a reaction
    //if(type == 'reaction') return false;
    //if(p.bot) return false; // Bots don't react!
    p = getP(p);
    if(get(state).startedGameEndActions){
        endCheckReactions({type, timing, possibleCards: 0, reactions: 0});
        return []; // No reactions once game is ended
    }
    if(type == 'play_activate' && params.actionDone){
        //console.log('converting '+type);
        type = params.actionDone;
    }
    // TODO reinstate the below if needed
   /* if(params.card && stackIncludes(getCard(params.card))){
        console.log('stack includes card, so not following reaction', getCard(params.card), get(state).cardStack)
        return;
    }*/

    let possibleCards = [];
    let replaced = false;
    let allReactions = [];

    state.update(s => {
        if(!s.cache) s.cache = {};
        //s.cache.replacedOriginal = false;
        return s;
    })

    let noOpponentReactions = false;
    if(ongoingPlayer(p).includes('no_opponent_reactions')) noOpponentReactions = true;
    

    for(let p of get(state).players){
        // !TODO remove stackIncludes if need be
        // !TODO add !c.activated if need be
        if(p.bot){
            // The bot doesn't react, except Special effects marked 'This operation applies to the Bot'
            possibleCards.push(...allScoreableCards(p).filter(c => getCardEffect(c, 'special').some(e => e.botToo)).map(c => { return {owner: p, card: c} }));
            continue;
        }
        if(noOpponentReactions && p.captain != get(state).players[get(state).currentPlayer].captain) continue; // Blocked reactions
        // NB no longer exclude cards in staging area, because special effects should trigger there. Passive, activation, reaction effects are already ruled out at the validEffect stage
        possibleCards.push(...cardsInPlay(p, false, true).filter(c => /*!stackIncludes(c) &&*/ get(state).cardLog[c.uniqueID].area != 'beamed' && /*!p.decks.play.includes(c) && */getCardEffect(c, 'all_reactions').length > 0).map(c => { return {owner: p, card: c} }))
        possibleCards.push(...p.decks.hand.filter(c => getCardEffect(c, 'support').length > 0).map(c => { return {owner: p, card: c} }))
        possibleCards.push(...allScoreableCards(p).filter(c => !possibleCards.some(cd => cd.card.uniqueID == c.uniqueID) && getCardEffect(c, 'special').length > 0).map(c => { return {owner: p, card: c} }));
        // see below for El-Aurians to enable...
        possibleCards.push(...[...getMarketCards(), ...get(state).commons.encounters].filter(c => getCardEffect(c, 'special').length > 0).map(c => { return {owner: activePlayer(), card: c} }))
    }
    if(p.supplementary){

    }
    perfCount('reaction.possibleCards', possibleCards.length);
    //console.log(cardsInPlay(p), possibleCards);
    for(let c of possibleCards){
        let {card, owner} = c;
        if(cannotDoOp(card, 'reaction', owner)) continue; // op impossible
        let effects = getCardEffect(card, 'all_reactions').filter(r => meetsThreshold(owner, r) && validEffect(card, r, owner));
        // Support is handled in validEffect now
        // if(p.decks.hand.some(cd => cd.uniqueID == card.uniqueID)) effects = getCardEffect(c, 'support').filter(r => meetsThreshold(owner, r) && validEffect(card, r, owner));
        //console.log('logging reaction effects for', card.name,  effects)
        let effectIndex = 0;
        for(let effect of effects){
            effectIndex++;
            let effectCode = `${card.uniqueID}.${effectIndex}`;
            let parentType = effect.type;
            let attack = effect.attack || false;
            //console.log(effect, p, owner, card, type, params);
            if(effect.trigger){
                // !! BELOW is old, ignore it
                if(effect.timing != timing) continue;
                //if(!cardsInPlay(p).some(c => c.uniqueID == card.uniqueID)) continue; // In case the card has gone out of play in the meantime
                if(effect.trigger(p, owner, card, type, params)){
                
                    /* state.update(s => {
                        s.reacting = true;
                        return s;
                    }) */
                    if(isMe(getPlayerIndex(owner))){
                        let t = params.parentType;
                        allReactions.push({
                            card: card.name,
                            text: effect.text,
                            attack,
                            //effectCode,
                            condition: () => isEligibleForReaction(card, t, effectCode), // why this?? -> , isInReactionStack(effectCode)),
                            p: getPlayerIndex(owner),
                            check: ['reaction', 'support'].includes(params.parentType) && !isInReactionStack(effectCode) ? `Trigger the ${params.parentType == 'support' ? 'Support effect' : 'reaction'} from ${card.name} (${effect.text})?` : false,
                            effect: async () => {
                                changePlayer(owner);
                                await doAction(owner, 'reaction', {p: getPlayerIndex(p), card: card.uniqueID, type, attack, params: {...params, parentType: effect.type}})
                                if(isMe(getPlayerIndex(p))) changePlayer(p);
                            }
                        })
                        
                    }else{
                        let t = params.parentType;
                        allReactions.push({
                            card: card.name,
                            text: effect.text,
                            attack,
                            //effectCode,
                            condition: () => isEligibleForReaction(card, t, effectCode), // why this?? -> , isInReactionStack(effectCode)),, isInReactionStack(effectCode)),
                            p: getPlayerIndex(owner),
                            check: !isInReactionStack(effectCode) ? `Trigger the ${params.parentType == 'support' ? 'Support effect' : 'reaction'} from ${card.name} (${effect.text})?` : false,
                            effect: async () => {
                                await launchReaction(owner, p, card, effect, type, attack, {...params, parentType: effect.type}, 'manual')
                            }
                        })
                        
                    }
                    /* state.update(s => {
                        s.reacting = false;
                        return s;
                    }) */
                }
            }else if(effect.effect){
                //Auto parsed so sift through
                let reactionTypes = ['reaction', 'condition']
                let reactions = effect.effect.filter(e => reactionTypes.includes(e.type) || Array.isArray(e) && e.some(r => reactionTypes.includes(r.type))).flat(3);
                //console.log(reactions, effect);
                let nested = [];
                for(let e of reactions){
                    if(e.timing && e.timing != timing) continue;
                    if(!e.timing && timing == 'before') continue; //default is after
                    params.parentType = parentType; // !!! NB was after if(e.condition) bit but that meant the autoCheck failed with passives...
                    //if(!cardsInPlay(p).some(c => c.uniqueID == card.uniqueID)) continue; // In case the card has gone out of play in the meantime
                    if(e.condition){
                        let acr = await autoCheckReaction(owner, p, card, e, type, params, timing);
                        if(acr){
                            let checkText = false;
                            if(acr.text){
                                checkText = acr.text; // will also fill in cache
                            }else if(['reaction', 'support'].includes(params.parentType)){
                                checkText = `Trigger the ${params.parentType == 'support' ? 'Support effect' : 'reaction'} from ${card.name} (${e.text})?`;
                            }
                            let t = params.parentType;
                            nested.push({
                                card: card.name,
                                text: e.text,
                                //effectCode,
                                attack,
                                p: getPlayerIndex(owner),
                                condition: () => isEligibleForReaction(card, t, effectCode), // why this?? -> , isInReactionStack(effectCode)),, isInReactionStack(effectCode)),
                                check: checkText,//['reaction', 'support'].includes(params.parentType) && !isInReactionStack(effectCode) ? `Trigger the ${params.parentType == 'support' ? 'Support effect' : 'reaction'} from ${card.name} (${e.text})?` : false,
                                effect: async () => {
                                    if(acr.func) acr.func();
                                    state.update(s => {
                                        if(!s.savedCache) s.savedCache = [];
                                        s.savedCache.push(clone(s.cache));
                                        return s;
                                    })

                                    if(owner.bot){
                                        // Bot-applicable Special: resolve directly for the bot, no offer to send
                                        await doAction(owner, 'reaction', {p: getPlayerIndex(p), card: card.uniqueID, effect: e, type, attack, params: {...params, parentType: effect.type, noCheck: true}, timing})
                                    }else if(isMe(getPlayerIndex(owner))){
                                        changePlayer(owner);
                                        //await autoReaction(owner, p, card, e, type, params, timing);
                                        // NB Mar 2025 I temporarily changed getPlayerIndex(p) below to getPlayerIndex(owner)
                                        // but then found the bug somewhere else
                                        // I still don't quite understand why it's not getPlayerIndex(owner) though
                                        // so if something else breaks, look here
                                        await doAction(owner, 'reaction', {p: getPlayerIndex(p), card: card.uniqueID, effect: e, type, attack, params: {...params, parentType: effect.type, noCheck: isMe(owner)}, timing})
                                        if(isMe(getPlayerIndex(p))) changePlayer(p);
                                    }else{
                                        params.timing = timing;
                                        await launchReaction(owner, p, card, e, type, attack, {...params, parentType: effect.type, noCheck: isMe(owner)/*, noCheck: true*/}, 'auto')
                                    }

                                    state.update(s => {
                                        let r = false;
                                        let a = false;
                                        let co = -1;
                                        if(s.cache.replacedOriginal) r = s.cache.replacedOriginal;
                                        if(s.cache.attackCancelled) a = s.cache.attackCancelled;
                                        if(s.cache.hasOwnProperty('cardOwner')) co = s.cache.cardOwner;
                                        if(s.savedCache && s.savedCache.length > 0) s.cache = s.savedCache.pop();
                                        if(r) s.cache.replacedOriginal = r;
                                        if(a) s.cache.attackCancelled = a;
                                        if(co != -1) s.cache.cardOwner = co;
                                        if(s.savedCache.length == 0) delete s.savedCache;
                                        return s;
                                    })
                                }
                            });
                        }
                        /*state.update(s => {
                            s.reacting = false;
                            return s;
                        })*/
                    }
                }
                // Linking up reactions – try it
                if(nested.length > 0){
                    let t = params.parentType;
                    allReactions.push({
                        card: card.name,
                        text: effect.text,
                        attack,
                        p: getPlayerIndex(owner),
                        condition: () => isEligibleForReaction(card, t, effectCode), // why this?? -> , isInReactionStack(effectCode)),, isInReactionStack(effectCode)),
                        check: nested[0] && nested[0].check ? nested[0].check : ['reaction', 'support'].includes(params.parentType) && !isInReactionStack(effectCode) ? `Trigger the ${params.parentType == 'support' ? 'Support effect' : 'reaction'} from ${card.name} (${effect.text})?` : false,
                        effect: async () => {
                            pushCurrentReaction(effectCode);
                            for(let e of nested){
                                if(!e.condition || e.condition()) await e.effect();
                            }
                            popCurrentReaction();
                        }
                    })
                }
                
            }
        }
        
    }


    // Check for custom mission completion triggers
    // !! TODO reinstate if ever more custom missions come in
    /*for(let m of p.dashboard.missions){
        let pct = get(res).parsedCardText[m.id];
        let missions = trawlFor(pct, 'custom_goal');
        if(!missions) continue;
        for(let mission of Array.from(new Set(missions))){
            if(checkCustomMissions(p, type, params, timing, mission)){
                let complete = await pause(`You have fulfilled the conditions of mission ${cc(m)}. Do you want to complete it and gain the reward?`, ['Yes', 'No']);
                if(complete == 'Yes'){
                    await completeMission(m);
                }
            }
        }
        
    }*/

    for(let p of get(state).players){
        let effectsToRemove = [];
        if(!p.hangingEffects) p.hangingEffects = [];
        for(let e of p.hangingEffects){
            if(e.timing == timing && e.condition){
                /*state.update(s => {
                    s.reacting = true;
                    return s;
                })*/
                //cardOnStack(card);
                //await autoReaction(owner, p, card, e, type, params, timing);
                //cardOffStack(card);
                let acr = await autoCheckReaction(owner, p, card, e, type, params, timing);
                if(acr){
                    let t = params.parentType;
                    let checkText = false;
                    if(acr.text){
                        checkText = acr.text; // will also fill in cache
                    }else if(['reaction', 'support'].includes(params.parentType)){
                        checkText = `Trigger the ${params.parentType == 'support' ? 'Support effect' : 'reaction'} from ${card.name} (${e.text})?`;
                    }
                    allReactions.push({
                        card: card.name,
                        text: e.text,
                        p: getPlayerIndex(p),
                        condition: () => isEligibleForReaction(card, t, effectCode), // why this?? -> , isInReactionStack(effectCode)),, isInReactionStack(effectCode)),
                        check: checkText, //['reaction', 'support'].includes(params.parentType) ? `Trigger the ${params.parentType == 'support' ? 'Support effect' : 'reaction'} from ${card.name} (${e.text})?` : false,
                        effect: async () => {
                            if(acr.func) acr.func();
                            await doAction(owner, 'reaction', {p, card: card.uniqueID, type,  attack, params: {...params, parentType: e.type, noCheck: isMe(owner)}, timing})
                        }
                    });

                    if(e.type == 'next_action') effectsToRemove.push(e)
                }
                /*state.update(s => {
                    s.reacting = false;
                    return s;
                })*/
            }
        }
        p.hangingEffects = p.hangingEffects.filter(e => !effectsToRemove.includes(e));
    }

    //console.log('checking replacedOrig', get(state).cache)
    if(!defer){
        await freeOrderActions(allReactions)
        endCheckReactions({type, timing, possibleCards: possibleCards.length, reactions: allReactions.length});
    }else{
        endCheckReactions({type, timing, possibleCards: possibleCards.length, reactions: allReactions.length});
        return allReactions;
    }
}

function uniqueName(c, list){
    let matches = list.filter(cd => cd.card == c.card)
    if(matches.length <= 1) return c.card;
    let count = 1;
    for(let cd of matches){
        if(cd == c) return `${c.card} ${count}`;
        count++;
    }
}

export async function freeOrderActions(actions, type = 'reactions', handleCancellation = false, refresh = false){
    // Jan 2026: need to think about how to make this resumable for async?
    // Also: it needs to be able to rescan after each action
    // How about if the action itself could be a function returning a list?
    actions = actions.filter(a => !a.condition || a.condition());
    if(actions.length == 0) return;
    //let savedStack = get(state).currentReaction;
    for(let a of actions){
        a.uniqueName = uniqueName(a, actions); // for the rest
    }
    if(actions.some(a => a.p != get(state).activePlayer)){
        // Do active player first then nonactive player
        let activeActions = actions.filter(a => a.p == get(state).activePlayer);
        let nonActiveActions = actions.filter(a => a.p != get(state).activePlayer);
        await freeOrderActions(activeActions);
        let p = get(state).activePlayer;
        //await changePlayer(nonActiveActions[0].p);
        //await freeOrderActions(nonActiveActions); // !!! TODO for network play this needs handling more centrally
        // !!! TODO if we do the above then ditch the launchReaction stuff or upgrade it
        if(isMe(nonActiveActions[0].p)){
            await changePlayer(nonActiveActions[0].p);
            await freeOrderActions(nonActiveActions); // So you can choose order
        }else{
            // Send across network – this still needs to happen?
            for(let a of nonActiveActions){
                //await changePlayer(a.p); // Removed because this should happen within the effect
                if(!a.condition || a.condition()) await a.effect();
            }
        }
        
        
        
        await changePlayer(p);
    }else{
        let options = actions.map(a => `${a.uniqueName} ${a.text}`);
        let doneOptions = [];
        while(true){
            if(refresh){
                let newActions = refresh(); 
                for(let n of newActions){
                    let old = actions.find(a => a.card == n.card && a.text == n.text);
                    if(old && old.uniqueName){
                        n.uniqueName = old.uniqueName;
                    }else{
                        n.uniqueName = uniqueName(n, newActions);
                    }
                }
                actions = newActions; // Pick up effects of cards that entered play mid-step (e.g. promoted via Sobras)
            }
            actions = actions.filter(a => !a.condition || a.condition());
            options = actions.map(a => `${a.uniqueName} ${a.text}`);
            options = options.filter(o => !doneOptions.some(dop => dop == o));
            if(options.length == 0) return;
            //if(options.length == 1) break; // To execute final one
            let choices = [...options];
            let remainingActions = actions.filter(a => options.some(o => o == `${a.uniqueName} ${a.text}`));
            if(remainingActions.every(a => a.check) && options.length > 1) choices.push('Finish'); // 
           // if(action.effectCode) pushCurrentReaction(action.effectCode); // So
            let choice = choices[0];
            if(options.length > 1){
                choice = await choose(`Multiple ${type} triggered: choose order to resolve`, choices);
            }
            if(choice == 'Finish') return; // Simply end
            let action = actions.find(a => choice == `${a.uniqueName} ${a.text}`);
            let savedState = perfMeasure('clone.freeOrderLoop', () => clone(get(state)));
            let doIt = true;
            if(choices.length == 1 && action.check){
                doIt = await choose(action.check, ['Yes', 'No']);
                if(doIt != 'Yes') return; //doIt = false;
            }
            try{
                await action.effect();
                doneOptions.push(choice);
                //options = options.filter(o => o != choice);
            }catch(e){
                if(handleCancellation && e == 'cancelled'){
                    state.update(s => {
                        return savedState;
                    })
                    continue;
                }else{
                    throw e;
                }
            }
            
            //options = options.filter(o => actions.some(a => (!a.condition || a.condition()) && o == `${a.card} ${a.text}`));
            //if(options.length == 0) return; // Leave it because none left to do
        }
        // Below no longer there because we have to do it within the loop always
        let action = actions.find(a => options[0] == `${a.uniqueName} ${a.text}`);
        let doIt = true;
        if(action.check){
            doIt = await choose(action.check, ['Yes', 'No']);
            if(doIt != 'Yes') doIt = false;
        }
        let savedState = perfMeasure('clone.freeOrderFinal', () => clone(get(state)));
        let wasCancelled = false;
        do{
            wasCancelled = false;
            try{
                if(doIt) await action.effect();
            }catch(e){
                if(handleCancellation && e == 'cancelled'){
                    state.update(s => {
                        return savedState;
                    })
                    wasCancelled = true;
                }else{
                    throw e;
                }
            }
        }while(wasCancelled);
    }
    /*state.update(s => {
        if(savedStack){
            s.currentReaction = savedStack;
        }else{
            delete s.currentReaction;
        }
        return s;
    })*/
}

export async function takeAction(p, type, params){
    let pn = getPlayerIndex(p);

    let response = {p, type, params};
    let preAfter = [];

    if((!params.auto || params.doReactions) && type != 'reaction' && !params.noReactions){ // Last one so that 'per' actions cause reaction checks (e.g. gain_tokens)
        console.log('manual reaction check', type)
        let savedCO, savedCV;
        if(get(state).cache){
            savedCO = get(state).cache.current_obj;
            savedCV =  get(state).cache.current_verb;
        }

        state.update(s => {
            if(!s.cache) s.cache = {};
            s.cache.current_obj = params.obj || params.card; // since it's manually fired
            s.cache.current_verb = {verb: type, obj: params.obj || params.card};
            return s;
        })

        console.log('takeAction: checking reactions before '+type, params)
        await checkForReactions(p, type, params, 'before');
        preAfter = await checkForReactions(p, type, params, 'after', true); // deferred
        console.log('preafter check', preAfter);
    
        state.update(s => {
            if(!s.cache) s.cache = {};
            delete s.cache.current_obj;
            delete s.cache.current_verb;
            if(savedCO) s.cache.current_obj = savedCO;
            if(savedCV) s.cache.current_verb = savedCV; 
            return s;
        })
    
        if(get(state).cache.replacedOriginal){
            let ro = get(state).cache.replacedOriginal;
            if(ro != params.card){
                console.log('takeAction: abandoning original since reaction triggered');
                state.update(s => {
                    //delete s.cache.cancelled;
                    s.cache.replacedOriginal = false;
                    return s;
                })
                return;  // Because it's been replaced
            }
        }
        if(params.attack && get(state).cache.attackCancelled && params.card != get(state).cache.attackCancelled){
            console.log("Attack effects cancelled")
            if(get(state).payingCost) throw 'uncompleted'; // To prevent resultant effect
            return; // because it's been cancelled
        }
    } 
    
    
    /*{
        p = response.p;
        type = response.type;
        params = response.params;
    }*/

    let action = allActions.find(a => a.type == type);
    if(!action){
        console.log('Unable to find action!');
        return 'failed';
    }

    // Where each object was beamed before the action moves it: "dismiss a [[person]] beamed to a
    // [[ship]] and exhaust that [[ship]]" binds to the dismissal's 'from' (bind_prev.js)
    let beamedFrom = [];
    if(params.slot !== undefined && params.slot !== null && !params.from){
        let log = get(state).cardLog || {};
        for(let o of possArray(params.obj).flat(2)){
            let id = typeof o == 'number' ? o : o && o.uniqueID;
            if(id && log[id] && log[id].area == 'beamed' && typeof log[id].deck == 'number') beamedFrom.push(log[id].deck);
        }
    }

    let res = await action.action(p, params);

    if(!params.keepLooksOpen) closeAllLooks(); // TODO could be (true); // Presuming you no longer need the decks when the action is done...? TODO maybe don't keep? see in gameplay

    // Parse-time backreferences: record this action's result against its slot in the current
    // frame, so resolvePrevObj can look it up instead of scanning the history. Accumulates,
    // because parsedAction calls doAction once per object of a multi-object action.
    // Always recorded, whether or not resolution reads it: see frames.js.
    recordSlot(params.slot, {obj: params.result || params.obj, to: params.to, from: params.from || (beamedFrom.length ? beamedFrom : undefined)});

    // Add the prev_obj here, but with a way of collating objects too
    logDid(params.card, true)
    state.update(s => {
        // TODO add in specific params too
        if(!s.cache) s.cache = {};
        //if(!s.cache.allPrev) s.cache.allPrev = [];
        if(!s.cache.allPrev) s.cache.allPrev = [];
        if(!s.cache.interimPrev) s.cache.interimPrev = [];
        if(!s.cache.prevVerbs) s.cache.prevVerbs = [];
        if((params.result || params.obj)){
            s.cache.prev_obj = params.result || params.obj;
            // !! TODO if it breaks, removed to_resolved
            s.cache.interimPrev = [s.cache.prev_obj, ...s.cache.interimPrev].flat(2);
            // NB below: only add 'to' if the text actually talks about 'to', not to 'here', to fix Archer Earth
            // and (Oct 2025) by fully filtering out non-named 'to' hopefully fix effects like Krenim Time-Ship
            if(nonCardListPrep(params.verb) &&  params.to && (params.to_resolved || (params.to_name && (!params.to_name.location || params.to_name.location != 'here')))) s.cache.interimPrev = [params.to, ...s.cache.interimPrev];
            // Likewise: add 'from' if explicitly named, for backreference
            // Sep 2026: reordered to put from after main object because that's how it should usually be
            // ...and also disabled unless obj is not a card,
            // because you basically don't (I think) get effects like 
            // 'warp a ship from a [[location]] and log it' that are intending to target
            // the location rather than the ship. I can only think of situations like 
            // Remove 2 [[dilithium]] from *Earth* and log it
            // where the main obj is not a card, so the target is the previous
            // Oct 2026: ...but a named [[location]] 'from' is still kept (after the card), so 'recall a ship
            // from the same [[location]]. If that [[location]] is neutral...' can find it (This far, no further!)
            if((typeof params.obj != 'number' || possArray(params.from).every(f => typeof f == 'number' && getCard(f) && matches(getCard(f), 'location'))) && nonCardListPrep(params.verb) && params.from && (params.from_name || params.from_resolved)) s.cache.interimPrev = [...s.cache.interimPrev, params.from];
            
            //s.cache.allPrev = [s.cache.prev_obj, ...s.cache.allPrev];
            let newVerb = {verb: type, obj: s.cache.prev_obj, num: params.num || s.cache.prev_obj.num || 1, card: params.card};
            if(params.to) newVerb.to = params.to;
            if(params.from) newVerb.from = params.from;
            newVerb.namedPreps = [];
            for(let p of ['to', 'from']){
                if(params[p] && params[`${p}_name`] || params[`${p}_resolved`]) newVerb.namedPreps.push(p);
            }
            s.cache.prevVerbs = [newVerb, ...s.cache.prevVerbs];
        }else{
            console.log('no object', params)
            // Still return num if poss
            let newVerb = {verb: type, obj: false, num: params.num || 0, card: params.card};
            if(params.to) newVerb.to = params.to;
            if(params.from) newVerb.from = params.from;
            newVerb.namedPreps = [];
            for(let p of ['to', 'from']){
                if(params[p] && params[`${p}_name`] || params[`${p}_resolved`]) newVerb.namedPreps.push(p);
            }
            s.cache.prevVerbs = [newVerb, ...s.cache.prevVerbs];
        }
        console.log(s.cache)
        console.log('attack cancelled?', s.cache.attackCancelled)
        return s;
    })

    if(!params.auto || params.doReactions && type != 'reaction'){
        let after = await checkForReactions(p, type, params, 'after', true);
        if(after.length > 0){
            after = after.filter(a => !preAfter.some(pa => pa.card == a.card && pa.text == a.text));
            preAfter = [...preAfter, ...after];
        }

        if(preAfter.length > 0){
            await freeOrderActions(preAfter);
        }else{
            console.log("takeAction: checking reactions after "+type, params)
            await checkForReactions(p, type, params, 'after'); 
        }
    }
    
    return res; // Will it work to do it like this?
}
